<div class="why-iquanta-modals">
    <div class="modal" id="NonEngineersQAVideos" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xl px-2">
            <div class="modal-content">

                <div class="modal-body">
                    <div class="modal-header-card mb-3 position-relative">
                        <h2 class="mb-0 d-flex align-items-center"><span class="f-light mr-4 d-none d-sm-block">iQuanta
                                Presents</span>Non Engineers Quant Conceptual Videos</h2>
                        <div data-dismiss="modal" class="close-button position-absolute">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 28 28"
                                fill="none">
                                <circle cx="14" cy="14" r="14" fill="#F9F4DD" />
                                <path
                                    d="M15.4164 14.3884L20.0068 9.80475C20.144 9.66753 20.2211 9.48142 20.2211 9.28736C20.2211 9.0933 20.144 8.90719 20.0068 8.76997C19.8696 8.63275 19.6835 8.55566 19.4895 8.55566C19.2954 8.55566 19.1093 8.63275 18.9721 8.76997L14.389 13.3609L9.80586 8.76997C9.66866 8.63275 9.48257 8.55566 9.28853 8.55566C9.09449 8.55566 8.9084 8.63275 8.77119 8.76997C8.63399 8.90719 8.55691 9.0933 8.55691 9.28736C8.55691 9.48142 8.63399 9.66753 8.77119 9.80475L13.3616 14.3884L8.77119 18.972C8.7029 19.0397 8.64869 19.1203 8.6117 19.2091C8.57471 19.2979 8.55566 19.3932 8.55566 19.4894C8.55566 19.5856 8.57471 19.6808 8.6117 19.7696C8.64869 19.8584 8.7029 19.939 8.77119 20.0068C8.83893 20.0751 8.91952 20.1293 9.00831 20.1663C9.0971 20.2033 9.19234 20.2223 9.28853 20.2223C9.38472 20.2223 9.47995 20.2033 9.56875 20.1663C9.65754 20.1293 9.73812 20.0751 9.80586 20.0068L14.389 15.4159L18.9721 20.0068C19.0399 20.0751 19.1205 20.1293 19.2093 20.1663C19.298 20.2033 19.3933 20.2223 19.4895 20.2223C19.5857 20.2223 19.6809 20.2033 19.7697 20.1663C19.8585 20.1293 19.9391 20.0751 20.0068 20.0068C20.0751 19.939 20.1293 19.8584 20.1663 19.7696C20.2033 19.6808 20.2223 19.5856 20.2223 19.4894C20.2223 19.3932 20.2033 19.2979 20.1663 19.2091C20.1293 19.1203 20.0751 19.0397 20.0068 18.972L15.4164 14.3884Z"
                                    fill="#1E1515" />
                            </svg>
                        </div>
                    </div>
                    <div class="modal-body-wrapper">
                        <div class="d-md-flex gap-3">
                            <div class="modal-text modal-right">
                                <div class="d-flex flex-wrap gap-3">
                                    <div class="img">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/home-image/non-engineer-01.webp"
                                            alt="Non Engineers QA Videos">
                                    </div>
                                    <div class="img">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/eng-4-66e80501bc130.webp"
                                            alt="Non Engineers QA Videos">
                                    </div>

                                    <div class="img mt-2">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/eng-1-66e805036e43a.webp"
                                            alt="Non Engineers QA Videos">
                                    </div>
                                    <div class="img mt-2">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/eng-2-66e80504d4122.webp"
                                            alt="Non Engineers QA Videos">
                                    </div>

                                </div>


                            </div>

                            <div class="modal-text modal-right pl-md-3 pr-md-4">
                                <div>
                                    <p class="f-light mb-3 text-justify mt-3 mt-md-0">Candidates aspiring to take
                                        the CAT 2025
                                        exam must
                                        enroll themselves into the CAT 2025 course at iQuanta. In the non-engineer
                                        CAT module candidates will get access to 80+ hours dedicated quant basic
                                        concept videos with aligned 6 to 10 NCERT. Every video will give both
                                        conceptual clarity and assistance with problem solving. In this
                                        non-engineering module at iQuanta students get complete clarity from extreme
                                        basics to moderate and difficult level concepts. Students who find the CAT
                                        QA section difficult must enroll into the CAT 2025 course to clear their
                                        basic concepts and watch these conceptual videos. After enrolling into the
                                        CAT course 2025 candidates will get access to non-engineer conceptual videos
                                        on their personal dashboard.</p>
                                    <h5 class="f-bold mb-2">Student Feedback on iQuanta’s Non Engineers’ QA Module
                                    </h5>
                                    <p class="f-light mb-3 text-justify">Once the candidates have enrolled
                                        themselves in iQuanta
                                        CAT coaching they will get access to non-engineers’ QA module which will be
                                        available on their personal dashboard. Students are in love with this
                                        non-engineers’ QA module. They get to clear their smallest doubts through
                                        this module on different topics such as Time & Work, Time, Speed & Distance,
                                        etc. Students have started loving maths after joining the iQuanta’s non
                                        engineers’ QA module. At iQuanta CAT coaching the candidates will get access
                                        to both dashboard assignments as well as practice sessions. The video
                                        lectures will help in concept building + problem solving.</p>

                                    <div class="d-md-flex gap-3" style="gap: 1.4rem;">
                                        <div class="img mb-3 mb-md-0">
                                            <img loading="lazy" class="img-fluid"
                                                src="https://media.iquanta.in/ui_images/home-image/non-engineer-02.webp"
                                                alt="Non Engineers QA Videos">
                                        </div>
                                        <div class="img">
                                            <img loading="lazy" class="img-fluid"
                                                src="https://media.iquanta.in/ui_images/home-image/non-engineer-03.webp"
                                                alt="Non Engineers QA Videos">
                                        </div>


                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <!-- Call Us modals -->
</div>

<div class="why-iquanta-modals why-iquanta-modals-lg">
    <div class="modal" id="CATBooks" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered px-2">
            <div class="modal-content">

                <div class="modal-body">
                    <div class="modal-header-card mb-3 position-relative">
                        <h2 class="mb-0 d-flex align-items-center"><span class="f-light mr-4 d-none d-sm-block">iQuanta
                                Presents</span>CAT BOOKS</h2>
                        <div data-dismiss="modal" class="close-button position-absolute">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 28 28"
                                fill="none">
                                <circle cx="14" cy="14" r="14" fill="#F9F4DD" />
                                <path
                                    d="M15.4164 14.3884L20.0068 9.80475C20.144 9.66753 20.2211 9.48142 20.2211 9.28736C20.2211 9.0933 20.144 8.90719 20.0068 8.76997C19.8696 8.63275 19.6835 8.55566 19.4895 8.55566C19.2954 8.55566 19.1093 8.63275 18.9721 8.76997L14.389 13.3609L9.80586 8.76997C9.66866 8.63275 9.48257 8.55566 9.28853 8.55566C9.09449 8.55566 8.9084 8.63275 8.77119 8.76997C8.63399 8.90719 8.55691 9.0933 8.55691 9.28736C8.55691 9.48142 8.63399 9.66753 8.77119 9.80475L13.3616 14.3884L8.77119 18.972C8.7029 19.0397 8.64869 19.1203 8.6117 19.2091C8.57471 19.2979 8.55566 19.3932 8.55566 19.4894C8.55566 19.5856 8.57471 19.6808 8.6117 19.7696C8.64869 19.8584 8.7029 19.939 8.77119 20.0068C8.83893 20.0751 8.91952 20.1293 9.00831 20.1663C9.0971 20.2033 9.19234 20.2223 9.28853 20.2223C9.38472 20.2223 9.47995 20.2033 9.56875 20.1663C9.65754 20.1293 9.73812 20.0751 9.80586 20.0068L14.389 15.4159L18.9721 20.0068C19.0399 20.0751 19.1205 20.1293 19.2093 20.1663C19.298 20.2033 19.3933 20.2223 19.4895 20.2223C19.5857 20.2223 19.6809 20.2033 19.7697 20.1663C19.8585 20.1293 19.9391 20.0751 20.0068 20.0068C20.0751 19.939 20.1293 19.8584 20.1663 19.7696C20.2033 19.6808 20.2223 19.5856 20.2223 19.4894C20.2223 19.3932 20.2033 19.2979 20.1663 19.2091C20.1293 19.1203 20.0751 19.0397 20.0068 18.972L15.4164 14.3884Z"
                                    fill="#1E1515" />
                            </svg>
                        </div>
                    </div>
                    <div class="modal-body-wrapper">

                        <div class="d-flex flex-wrap gap-3">
                            <div class="modal-text modal-big modal-right">
                                <div class="d-flex flex-wrap gap-3">
                                    <div class="img">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/booksss-66e80d0d9b454.webp"
                                            alt="CAT Coaching">
                                    </div>

                                </div>

                            </div>
                            <div class="modal-text modal-right">
                                <div>
                                    <p class="f-light mb-3 text-justify">Students who are aspiring to take the CAT
                                        exam must check the most updated CAT books provided by iQuanta. They will
                                        get access to 12 sets of CAT material updated as per latest CAT trends. The
                                        study material will consist of 5 QA books consisting of 2350 questions on
                                        number system, arithmetic, algebra, geometry, modern maths. Two books on LR
                                        and two books on DI with around 440 LRDI sets with 1760 questions. They will
                                        also get 2RC and 1VA books consisting of 1160 questions. In order to ace the
                                        CAT preparation it is very important that the candidates choose the right
                                        books. The books that contain the updated CAT pattern providing ample amount
                                        of content are the best for the students. These books are specially designed
                                        by experts to meet the needs of the latest CAT pattern. iQuanta is known for
                                        its relevant content as proved by best results in the CAT exam with several
                                        questions similar to what was taught in the classes.</p>
                                </div>
                            </div>

                            <div class="modal-text modal-right">
                                <h5 class="f-bold mb-2">What students say about iQuanta CAT Books :
                                </h5>
                                <p class="f-light mb-3 text-justify">Students are really impressed by iQuanta CAT
                                    books. Students are really impressed at the neat and handy packaging of the CAT
                                    books provided by iQuanta. The books provide updated content as per the latest
                                    CAT exam pattern. Great attention has been put to detail while preparing these
                                    books. iQuanta provides the best CAT books to the aspirants to ace the CAT
                                    preparation. Students who are planning to take the CAT exam must purchase the 12
                                    sets of iQuanta CAT books updated as per the latest CAT trends.</p>
                                <div class="gallery-div d-flex flex-wrap gap-3">
                                    <div class="img ">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/books-2.webp"
                                            alt="CAT Coaching">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/books-5.webp"
                                            alt="CAT Coaching">
                                    </div>

                                    <div class="img ">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/books-3.webp"
                                            alt="CAT Coaching">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/books-6.webp"
                                            alt="CAT Coaching">


                                    </div>

                                    <div class="img ">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/books-4.webp"
                                            alt="CAT Coaching">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/books-1.webp"
                                            alt="CAT Coaching">

                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<div class="why-iquanta-modals why-iquanta-modals-med">
    <div class="modal" id="VarcConceptualVideos" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered  px-2">
            <div class="modal-content">

                <div class="modal-body">
                    <div class="modal-header-card mb-3 position-relative">
                        <h2 class="mb-0 d-flex align-items-center"><span class="f-light mr-4 d-none d-sm-block">iQuanta
                                Presents</span>Engineers' VARC Conceptual Videos</h2>
                        <div data-dismiss="modal" class="close-button position-absolute">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 28 28"
                                fill="none">
                                <circle cx="14" cy="14" r="14" fill="#F9F4DD" />
                                <path
                                    d="M15.4164 14.3884L20.0068 9.80475C20.144 9.66753 20.2211 9.48142 20.2211 9.28736C20.2211 9.0933 20.144 8.90719 20.0068 8.76997C19.8696 8.63275 19.6835 8.55566 19.4895 8.55566C19.2954 8.55566 19.1093 8.63275 18.9721 8.76997L14.389 13.3609L9.80586 8.76997C9.66866 8.63275 9.48257 8.55566 9.28853 8.55566C9.09449 8.55566 8.9084 8.63275 8.77119 8.76997C8.63399 8.90719 8.55691 9.0933 8.55691 9.28736C8.55691 9.48142 8.63399 9.66753 8.77119 9.80475L13.3616 14.3884L8.77119 18.972C8.7029 19.0397 8.64869 19.1203 8.6117 19.2091C8.57471 19.2979 8.55566 19.3932 8.55566 19.4894C8.55566 19.5856 8.57471 19.6808 8.6117 19.7696C8.64869 19.8584 8.7029 19.939 8.77119 20.0068C8.83893 20.0751 8.91952 20.1293 9.00831 20.1663C9.0971 20.2033 9.19234 20.2223 9.28853 20.2223C9.38472 20.2223 9.47995 20.2033 9.56875 20.1663C9.65754 20.1293 9.73812 20.0751 9.80586 20.0068L14.389 15.4159L18.9721 20.0068C19.0399 20.0751 19.1205 20.1293 19.2093 20.1663C19.298 20.2033 19.3933 20.2223 19.4895 20.2223C19.5857 20.2223 19.6809 20.2033 19.7697 20.1663C19.8585 20.1293 19.9391 20.0751 20.0068 20.0068C20.0751 19.939 20.1293 19.8584 20.1663 19.7696C20.2033 19.6808 20.2223 19.5856 20.2223 19.4894C20.2223 19.3932 20.2033 19.2979 20.1663 19.2091C20.1293 19.1203 20.0751 19.0397 20.0068 18.972L15.4164 14.3884Z"
                                    fill="#1E1515" />
                            </svg>
                        </div>
                    </div>
                    <div class="modal-body-wrapper">
                        <div class="d-md-flex gap-3">
                            <div class="modal-text modal-big modal-right">
                                <div class="d-md-flex gap-3">
                                    <div class="img">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/eng-vrc-1-66e805a4e09d3.webp"
                                            alt="Engineers' VARC Conceptual Videos">
                                    </div>
                                    <div class="modal-sub-text">
                                        <h5 class="f-bold mb-2">Purpose
                                        </h5>
                                        <p class="f-light mb-3 text-justify">Engineers’ VARC CAT conceptual videos
                                            are very helpful for the students who are weak in grammar and
                                            communication. There are videos on different parts of the VARC section
                                            such as 40 videos on RC, 12 CAT VA videos with 10 VA questions, 7
                                            strategy based videos. Students will get access to 60+ videos with 30
                                            hours of VARC niche content only for CAT. Videos are there on different
                                            genres of RC such as environment, business/economics, history,
                                            arts/culture, philosophy/psychology, society and politics. The CAT VA
                                            videos include 10 parajumbles, 10 para summary, 10 critical reasoning,
                                            10 sentence correction, 10 fill in the blanks, 10 odd one out. The
                                            strategy videos include 7 videos with strategy on topics such as RC
                                            reading strategy, PJ solving strategy, PS strategy, CR strategy, SC
                                            strategy, RC option elimination strategy and lastly fill in the blanks
                                            strategy.</p>
                                    </div>
                                </div>
                                <div class="d-md-flex gap-3 mt-4">
                                    <div class="text-bg">
                                        <h5 class="f-bold mb-2">RC Videos
                                        </h5>
                                        <ul class="list-unstyled">
                                            <li><a class="f-light">40 Videos across different Genre explaining RCs
                                                    in depth</a></li>
                                            <li><a class="f-light">Business / Economics : <strong>5
                                                        Videos</strong></a></li>
                                            <li><a class="f-light">Environment : <strong>5</strong></a></li>
                                            <li><a class="f-light">Science and Technology: <strong>5</strong></a>
                                            </li>
                                            <li><a class="f-light">History : <strong>5</strong></a></li>
                                            <li><a class="f-light">Arts and Culture: <strong>5</strong></a></li>
                                            <li><a class="f-light">Philosophy/ psychology : <strong>5</strong></a>
                                            </li>
                                            <li><a class="f-light">Society and Politics : <strong>5</strong></a>
                                            </li>
                                            <li><a class="f-light">Miscellaneous: <strong>5</strong></a></li>
                                        </ul>
                                    </div>
                                    <div class="text-bg">
                                        <h5 class="f-bold mb-2">CAT VA Videos
                                        </h5>
                                        <p class="f-light mb-3 text-justify">12 Videos with 10 VA questions solving
                                            each</p>
                                        <ul class="list-unstyled">
                                            <li><a class="f-light">10 ParaJumbles</a></li>
                                            <li><a class="f-light">10 Odd One Out</a></li>
                                            <li><a class="f-light">10 ParaSummary</a></li>
                                            <li><a class="f-light">10 Critical Reasoning</a></li>
                                            <li><a class="f-light">10 Sentence Correction</a></li>
                                            <li><a class="f-light">10 FIB</a></li>
                                        </ul>
                                    </div>
                                    <div class="text-bg">
                                        <h5 class="f-bold mb-2">Strategy Videos
                                        </h5>
                                        <p class="f-light mb-3 text-justify">7 videos with strategy on each of the
                                            below topics</p>
                                        <ul class="list-unstyled">
                                            <li><a class="f-light">RC Reading strategy</a></li>
                                            <li><a class="f-light">RC Option elimination strategy</a></li>
                                            <li><a class="f-light">PJ Solving strategy</a></li>
                                            <li><a class="f-light">PS Strategy</a></li>
                                            <li><a class="f-light">CR Strategy</a></li>
                                            <li><a class="f-light">SC Strategy</a></li>
                                            <li><a class="f-light">FIB Strategy</a></li>
                                        </ul>
                                    </div>
                                </div>

                            </div>

                            <div class="modal-text modal-right modal-small pl-3 pr-4">
                                <div class="text-bg">
                                    <h5 class="f-bold mb-2">Total 60+ Videos with 30 Hours of VARC Niche Content for
                                        CAT only
                                    </h5>
                                    <p class="f-light mb-3 text-justify">The plan is to make a CAT VARC Product
                                        which will have Engineer's way of Cracking VARC. Aspirants feel that
                                        solutions to VARC are ambiguous but CAT guys want you to go for it in a
                                        certain way. The same will be available in this Product at one place- an
                                        alternate version of Non Engineer's QA Module at iQuanta.</p>
                                    <p class="f-light mb-3 text-justify">We will also keep bite size videos(10-15
                                        mins) on all necessary concepts such as how to understand tone, assumptions,
                                        inferences etc. The intent is on getting to different CAT levels like to
                                        90%ile, 95%ile or to a 99.9%ile without all bullsh*t other coaching provide.
                                    </p>
                                    <p class="f-light mb-3 text-justify">Engineer's VARC is intended to be the most
                                        efficient way of acing CAT VARC for the weakest of student. So this product
                                        will be exclusive to those who are weak in VARC.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<div class="why-iquanta-modals why-iquanta-modals-lg">
    <div class="modal" id="ClassFeedBack" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered px-2">
            <div class="modal-content">

                <div class="modal-body">
                    <div class="modal-header-card mb-3 position-relative">
                        <h2 class="d-flex align-items-center">Class Feedback</h2>
                        <div data-dismiss="modal" class="close-button position-absolute">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 28 28"
                                fill="none">
                                <circle cx="14" cy="14" r="14" fill="#F9F4DD" />
                                <path
                                    d="M15.4164 14.3884L20.0068 9.80475C20.144 9.66753 20.2211 9.48142 20.2211 9.28736C20.2211 9.0933 20.144 8.90719 20.0068 8.76997C19.8696 8.63275 19.6835 8.55566 19.4895 8.55566C19.2954 8.55566 19.1093 8.63275 18.9721 8.76997L14.389 13.3609L9.80586 8.76997C9.66866 8.63275 9.48257 8.55566 9.28853 8.55566C9.09449 8.55566 8.9084 8.63275 8.77119 8.76997C8.63399 8.90719 8.55691 9.0933 8.55691 9.28736C8.55691 9.48142 8.63399 9.66753 8.77119 9.80475L13.3616 14.3884L8.77119 18.972C8.7029 19.0397 8.64869 19.1203 8.6117 19.2091C8.57471 19.2979 8.55566 19.3932 8.55566 19.4894C8.55566 19.5856 8.57471 19.6808 8.6117 19.7696C8.64869 19.8584 8.7029 19.939 8.77119 20.0068C8.83893 20.0751 8.91952 20.1293 9.00831 20.1663C9.0971 20.2033 9.19234 20.2223 9.28853 20.2223C9.38472 20.2223 9.47995 20.2033 9.56875 20.1663C9.65754 20.1293 9.73812 20.0751 9.80586 20.0068L14.389 15.4159L18.9721 20.0068C19.0399 20.0751 19.1205 20.1293 19.2093 20.1663C19.298 20.2033 19.3933 20.2223 19.4895 20.2223C19.5857 20.2223 19.6809 20.2033 19.7697 20.1663C19.8585 20.1293 19.9391 20.0751 20.0068 20.0068C20.0751 19.939 20.1293 19.8584 20.1663 19.7696C20.2033 19.6808 20.2223 19.5856 20.2223 19.4894C20.2223 19.3932 20.2033 19.2979 20.1663 19.2091C20.1293 19.1203 20.0751 19.0397 20.0068 18.972L15.4164 14.3884Z"
                                    fill="#1E1515" />
                            </svg>
                        </div>
                    </div>
                    <div class="modal-body-wrapper">

                        <div class="d-md-flex flex-wrap gap-3">
                            <div class="modal-text modal-big modal-right">
                                <div class="d-md-flex flex-wrap gap-3">
                                    <div class="img">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/home-image/questions-in-cat-2024.webp"
                                            alt="CAT Coaching">
                                    </div>

                                </div>

                            </div>
                            <div class="modal-text modal-right">
                                <div>
                                    <p class="f-light mb-3 text-justify">Know about the CAT Class Feedback given by
                                        different CAT aspirants at iQuanta. In 2024, students witnessed 20+
                                        questions directly from iQuanta classes. This shows that iQuanta CAT class
                                        provides the most relevant study material following the latest exam pattern.
                                        Aspirants at iQuanta CAT class get 24*7 instant doubt solving assistance for
                                        smooth preparation of the CAT exam. They find the live application mode of
                                        teaching at iQuanta classes very helpful. Aspirants are in love with the
                                        non-engineering module at iQuanta CAT class. iQuanta CAT classes make the
                                        toughest CAT topics easier for the students. After attending CAT classes at
                                        iQuanta mathematics has become very easy for the non-engineer students.
                                        Students find the CAT exam classes at iQuanta very interactive and that
                                        helps them with their preparation.</p>
                                </div>
                            </div>

                            <div class="modal-text modal-right">
                                <h5 class="f-bold mb-2">Content Relevancy
                                </h5>
                                <div class="gallery-div d-md-flex flex-wrap gap-3">
                                    <div class="img d-md-flex flex-wrap gap-3">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/content-1-66e7f1492d261.webp"
                                            alt="CAT Coaching">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/content-2-66e7f1473e8f8.webp"
                                            alt="CAT Coaching">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/content-7-66e7f1470250b.webp"
                                            alt="CAT Coaching">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/result-screen-0208.webp"
                                            alt="CAT Coaching">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/result-screen-0209.webp"
                                            alt="CAT Coaching">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/result-screen-0210.webp"
                                            alt="CAT Classes">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/result-screen-0211.webp"
                                            alt="CAT Classes">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/result-screen-0212.webp"
                                            alt="CAT Classes">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/result-screen-0213.webp"
                                            alt="CAT Classes">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/result-screen-0214.webp"
                                            alt="CAT Classes">

                                    </div>

                                    <div class="img d-md-flex flex-wrap gap-3">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/content-3-66e7f13fa6db2.webp"
                                            alt="CAT Coaching">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/content-4-66e7f13f56877.webp"
                                            alt="CAT Coaching">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/content-8-66e7f13e62179.webp"
                                            alt="CAT Coaching">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/result-screen-0215.webp"
                                            alt="CAT Coaching">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/result-screen-0216.webp"
                                            alt="CAT Classes">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/result-screen-0215.webp"
                                            alt="CAT Classes">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/result-screen-0216.webp"
                                            alt="CAT Classes">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/result-screen-0217.webp"
                                            alt="CAT Classes">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/result-screen-0218.webp"
                                            alt="CAT Classes">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/result-screen-0219.webp"
                                            alt="CAT Classes">

                                    </div>

                                    <div class="img d-md-flex flex-wrap gap-3">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/content-5-66e7f136cab99.webp"
                                            alt="CAT Coaching">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/content-6-66e7f1366bf0c.webp"
                                            alt="CAT Coaching">
                                        <img loading="lazy" class="img-fluid" alt="CAT Coaching"
                                            src="https://media.iquanta.in/ui_images/result-screen-0220.webp">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/result-screen-0221.webp"
                                            alt="CAT Classes">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/result-screen-0222.webp"
                                            alt="CAT Classes">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/result-screen-0223.webp"
                                            alt="CAT Classes">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/result-screen-0207.webp"
                                            alt="CAT Classes">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/result-screen-0204.webp"
                                            alt="CAT Classes">

                                    </div>

                                </div>
                            </div>
                            <div class="modal-text modal-right">
                                <div>
                                    <h5 class="f-bold mb-2">iQuanta Class Feedback
                                    </h5>
                                    <div class="gallery-div d-md-flex flex-wrap gap-3">
                                        <div class="img d-md-flex flex-wrap gap-3">
                                            <img loading="lazy" class="img-fluid"
                                                src="https://media.iquanta.in/ui_images/new-home/cls-1-66e7fa6a8e917.webp"
                                                alt="CAT Coaching">
                                            <img loading="lazy" class="img-fluid"
                                                src="https://media.iquanta.in/ui_images/new-home/cls-4-66e7fa6541129.webp"
                                                alt="CAT Coaching">
                                           
                                            <img loading="lazy" class="img-fluid"
                                                src="https://media.iquanta.in/ui_images/new-home/cls-10-66e7fa60381ba.webp"
                                                alt="CAT Coaching">
                                            <img loading="lazy" class="img-fluid"
                                                src="https://media.iquanta.in/ui_images/new-home/cls-13-66e7fa5b73463.webp"
                                                alt="CAT Coaching">
                                            <img loading="lazy" class="img-fluid"
                                                src="https://media.iquanta.in/ui_images/new-home/cls-16-66e7fa5923d81.webp"
                                                alt="CAT Coaching">
                                            <img loading="lazy" class="img-fluid"
                                                src="https://media.iquanta.in/ui_images/new-home/cls-19-66e7fa56a7f15.webp"
                                                alt="CAT Coaching">
                                            <img loading="lazy" class="img-fluid"
                                                src="https://media.iquanta.in/ui_images/new-home/cls-22-66e7fa568ce03.webp"
                                                alt="CAT Coaching">
                                            <img loading="lazy" class="img-fluid"
                                                src="https://media.iquanta.in/ui_images/new-home/cls-25-66e7fa51add00.webp"
                                                alt="CAT Coaching">
                                            <img loading="lazy" class="img-fluid"
                                                src="https://media.iquanta.in/ui_images/result-screen-0225.webp"
                                                alt="CAT Coaching">
                                        </div>

                                        <div class="img d-md-flex flex-wrap gap-3">
                                            <img loading="lazy" class="img-fluid"
                                                src="https://media.iquanta.in/ui_images/new-home/cls-2-66e7fa67ebab8.webp"
                                                alt="CAT Coaching">
                                            <img loading="lazy" class="img-fluid"
                                                src="https://media.iquanta.in/ui_images/new-home/cls-5-66e7fa652a19b.webp"
                                                alt="CAT Coaching">
                                            <img loading="lazy" class="img-fluid"
                                                src="https://media.iquanta.in/ui_images/new-home/cls-8-66e7fa6055dab.webp"
                                                alt="CAT Coaching">
                                            <img loading="lazy" class="img-fluid"
                                                src="https://media.iquanta.in/ui_images/new-home/cls-11-66e7fa5e00666.webp"
                                                alt="CAT Coaching">
                                            <img loading="lazy" class="img-fluid"
                                                src="https://media.iquanta.in/ui_images/result-screen-0226.webp"
                                                alt="CAT Coaching">
                                            <img loading="lazy" class="img-fluid"
                                                src="https://media.iquanta.in/ui_images/result-screen-0227.webp"
                                                alt="CAT Coaching">
                                            <img loading="lazy" class="img-fluid"
                                                src="https://media.iquanta.in/ui_images/result-screen-0228.webp"
                                                alt="CAT Coaching">
                                            <img loading="lazy" class="img-fluid"
                                                src="https://media.iquanta.in/ui_images/new-home/cls-23-66e7fa54484b7.webp"
                                                alt="CAT Coaching">
                                            <img loading="lazy" class="img-fluid"
                                                src="https://media.iquanta.in/ui_images/result-screen-0228.webp"
                                                alt="CAT Coaching">
                                            <img loading="lazy" class="img-fluid"
                                                src="https://media.iquanta.in/ui_images/new-home/cls-29-66e7fa5197c1f.webp"
                                                alt="CAT Coaching">
                                        </div>

                                        <div class="img d-md-flex flex-wrap gap-3">
                                            <img loading="lazy" class="img-fluid"
                                                src="https://media.iquanta.in/ui_images/new-home/cls-3-66e7fa67d51e2.webp"
                                                alt="CAT Coaching">
                                            <img loading="lazy" class="img-fluid"
                                                src="https://media.iquanta.in/ui_images/new-home/cls-6-66e7fa62bd65e.webp"
                                                alt="CAT Coaching">

                                            <img loading="lazy" class="img-fluid"
                                                src="https://media.iquanta.in/ui_images/new-home/cls-12-66e7fa5d8e615.webp"
                                                alt="CAT Coaching">
                                            <img loading="lazy" class="img-fluid"
                                                src="https://media.iquanta.in/ui_images/new-home/cls-15-66e7fa5b19b87.webp"
                                                alt="CAT Coaching">
                                            <img loading="lazy" class="img-fluid"
                                                src="https://media.iquanta.in/ui_images/new-home/cls-18-66e7fa58e916b.webp"
                                                alt="CAT Coaching">
                                            <img loading="lazy" class="img-fluid"
                                                src="https://media.iquanta.in/ui_images/result-screen-0229.webp"
                                                alt="CAT Coaching">
                                            <img loading="lazy" class="img-fluid"
                                                src="https://media.iquanta.in/ui_images/new-home/cls-24-66e7fa5401632.webp"
                                                alt="CAT Coaching">
                                            <img loading="lazy" class="img-fluid"
                                                src="https://media.iquanta.in/ui_images/new-home/cls-27.webp"
                                                alt="CAT Coaching">
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<div class="why-iquanta-modals why-iquanta-modals-small">
    <div class="modal" id="DashboardAssignments" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered px-2">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="modal-header-card mb-3 position-relative">
                        <h2 class="mb-0 d-flex align-items-center"><span class="f-light mr-4 d-none d-sm-block">iQuanta
                                Presents</span>Dashboard Assignments</h2>
                        <div data-dismiss="modal" class="close-button position-absolute">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 28 28"
                                fill="none">
                                <circle cx="14" cy="14" r="14" fill="#F9F4DD" />
                                <path
                                    d="M15.4164 14.3884L20.0068 9.80475C20.144 9.66753 20.2211 9.48142 20.2211 9.28736C20.2211 9.0933 20.144 8.90719 20.0068 8.76997C19.8696 8.63275 19.6835 8.55566 19.4895 8.55566C19.2954 8.55566 19.1093 8.63275 18.9721 8.76997L14.389 13.3609L9.80586 8.76997C9.66866 8.63275 9.48257 8.55566 9.28853 8.55566C9.09449 8.55566 8.9084 8.63275 8.77119 8.76997C8.63399 8.90719 8.55691 9.0933 8.55691 9.28736C8.55691 9.48142 8.63399 9.66753 8.77119 9.80475L13.3616 14.3884L8.77119 18.972C8.7029 19.0397 8.64869 19.1203 8.6117 19.2091C8.57471 19.2979 8.55566 19.3932 8.55566 19.4894C8.55566 19.5856 8.57471 19.6808 8.6117 19.7696C8.64869 19.8584 8.7029 19.939 8.77119 20.0068C8.83893 20.0751 8.91952 20.1293 9.00831 20.1663C9.0971 20.2033 9.19234 20.2223 9.28853 20.2223C9.38472 20.2223 9.47995 20.2033 9.56875 20.1663C9.65754 20.1293 9.73812 20.0751 9.80586 20.0068L14.389 15.4159L18.9721 20.0068C19.0399 20.0751 19.1205 20.1293 19.2093 20.1663C19.298 20.2033 19.3933 20.2223 19.4895 20.2223C19.5857 20.2223 19.6809 20.2033 19.7697 20.1663C19.8585 20.1293 19.9391 20.0751 20.0068 20.0068C20.0751 19.939 20.1293 19.8584 20.1663 19.7696C20.2033 19.6808 20.2223 19.5856 20.2223 19.4894C20.2223 19.3932 20.2033 19.2979 20.1663 19.2091C20.1293 19.1203 20.0751 19.0397 20.0068 18.972L15.4164 14.3884Z"
                                    fill="#1E1515" />
                            </svg>
                        </div>
                    </div>
                    <div class="modal-body-wrapper">
                        <div class="flex-wrap gap-3">
                            <div class="modal-text modal-big modal-right">
                                <div class="img">
                                    <img loading="lazy" class="img-fluid"
                                        src="https://media.iquanta.in/ui_images/new-dashboard.webp"
                                        alt="Dashboard Assignments">
                                </div>
                                <div class="modal-sub-text mt-4 px-3">
                                    <p class="f-light mb-0 text-center">In order to access the iQuanta dashboard the
                                        candidates are required to enroll themselves into iQuanta CAT online
                                        classes. Once a topic has been covered in the live and application classes
                                        the students will get an assignment in their personal dashboard to practice.
                                        This will help to analyze their understanding and application of concepts.
                                        These practice questions are of different types and difficulty levels. These
                                        questions are prepared based on actual CAT difficulty level. iQuanta CAT
                                        online coaching will guide the students with the help of these dashboard
                                        assignments to ace their CAT preparation.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="why-iquanta-modals">
    <div class="modal" id="DualPedagogy" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xl px-2">
            <div class="modal-content">

                <div class="modal-body">
                    <div class="modal-header-card mb-3 position-relative">
                        <h2 class="mb-0 d-flex align-items-center"><span class="f-light mr-4 d-none d-sm-block">iQuanta
                                Presents</span>What is Dual Pedagogy in iQuanta CAT Classes?</h2>
                        <div data-dismiss="modal" class="close-button position-absolute">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 28 28"
                                fill="none">
                                <circle cx="14" cy="14" r="14" fill="#F9F4DD" />
                                <path
                                    d="M15.4164 14.3884L20.0068 9.80475C20.144 9.66753 20.2211 9.48142 20.2211 9.28736C20.2211 9.0933 20.144 8.90719 20.0068 8.76997C19.8696 8.63275 19.6835 8.55566 19.4895 8.55566C19.2954 8.55566 19.1093 8.63275 18.9721 8.76997L14.389 13.3609L9.80586 8.76997C9.66866 8.63275 9.48257 8.55566 9.28853 8.55566C9.09449 8.55566 8.9084 8.63275 8.77119 8.76997C8.63399 8.90719 8.55691 9.0933 8.55691 9.28736C8.55691 9.48142 8.63399 9.66753 8.77119 9.80475L13.3616 14.3884L8.77119 18.972C8.7029 19.0397 8.64869 19.1203 8.6117 19.2091C8.57471 19.2979 8.55566 19.3932 8.55566 19.4894C8.55566 19.5856 8.57471 19.6808 8.6117 19.7696C8.64869 19.8584 8.7029 19.939 8.77119 20.0068C8.83893 20.0751 8.91952 20.1293 9.00831 20.1663C9.0971 20.2033 9.19234 20.2223 9.28853 20.2223C9.38472 20.2223 9.47995 20.2033 9.56875 20.1663C9.65754 20.1293 9.73812 20.0751 9.80586 20.0068L14.389 15.4159L18.9721 20.0068C19.0399 20.0751 19.1205 20.1293 19.2093 20.1663C19.298 20.2033 19.3933 20.2223 19.4895 20.2223C19.5857 20.2223 19.6809 20.2033 19.7697 20.1663C19.8585 20.1293 19.9391 20.0751 20.0068 20.0068C20.0751 19.939 20.1293 19.8584 20.1663 19.7696C20.2033 19.6808 20.2223 19.5856 20.2223 19.4894C20.2223 19.3932 20.2033 19.2979 20.1663 19.2091C20.1293 19.1203 20.0751 19.0397 20.0068 18.972L15.4164 14.3884Z"
                                    fill="#1E1515" />
                            </svg>
                        </div>
                    </div>
                    <div class="modal-body-wrapper">
                        <div class="d-md-flex gap-3">
                            <div class="modal-text modal-right">
                                <div class="d-md-flex flex-wrap gap-3">
                                    <div class="img">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/pedagogy-1-66e80722cbee9.webp"
                                            alt="Dual Pedagogy in iQuanta CAT Classes">
                                    </div>
                                    <div class="img mt-2 mt-md-0">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/pedagogy-2-66e8072239ee6.webp"
                                            alt="Dual Pedagogy in iQuanta CAT Classes">
                                    </div>

                                    <div class="img mt-2">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/pedagogy-3-66e80720ad327.webp"
                                            alt="Dual Pedagogy in iQuanta CAT Classes">
                                    </div>
                                    <div class="img mt-2 px-5">
                                        <img loading="lazy" class="img-fluid px-2"
                                            src="https://media.iquanta.in/ui_images/new-home/dual-peda-2-66e8071fa18b2.webp"
                                            alt="Dual Pedagogy in iQuanta CAT Classes">
                                    </div>

                                </div>
                                <div class="mt-3">
                                    <p class="f-light mb-3 text-justify">CAT is an aptitude based test therefore,
                                        not only mugging up the basic concepts but it's also about being thorough
                                        with the syllabus, paper pattern, etc. The concept of dual pedagogy involves
                                        both application classes as well as live interactive classes. The
                                        application class provides instant doubt solving throughout the class
                                        whereas the live interactive classes are driven by mentors who focus on
                                        covering the conceptual theories and formulae. Students are in love with the
                                        Live+Application mode of teaching at iQuanta CAT online classes. At iQuanta
                                        CAT online coaching students will not only get to learn the concepts but
                                        also learn the application of them to different types of questions.</p>
                                </div>
                            </div>

                            <div class="modal-text modal-right pl-md-3 pr-md-4">
                                <div>
                                    <h5 class="f-bold mb-2">So what is Dual Pedagogy and how does it help the
                                        iQuanta students?
                                    </h5>
                                    <p class="f-light mb-3 text-justify">Conceptual Live Sessions : The live
                                        conceptual classes are mentor driven traditional classes where the teachers
                                        will be teacing on a board first covering the conceptual theories and
                                        formulae. This will then be followed by solving a few easy to moderate level
                                        questions.</p>
                                    <p class="f-light mb-3 text-justify">Application Based Live Sessions :
                                        Application based classes are mentor driven sessions as well but not in the
                                        old ways. First a concept video of 4-5 minutes is shared with the students
                                        which is then followed by 4-5 questions on that particular concept. So
                                        you'll be solving 20-25 questions in a single application class on a
                                        particular topic. The application classes ensure that along with learning
                                        the concepts, you're also learning how to apply them to different types of
                                        questions.</p>
                                    <p class="f-light mb-3 text-justify">These classes are then followed by Topic
                                        wise assignments, daily practice and marathon sessions. This combination
                                        ensures that you are well versed with each of the topics before the CAT exam
                                        day.</p>
                                    <div class="d-flex gap-3 justify-content-end" style="gap: 1.4rem;">
                                        <div class="img">
                                            <img loading="lazy" class="img-fluid"
                                                src="https://media.iquanta.in/ui_images/new-home/dual-peda-1-66e8071f6583f.webp"
                                                alt="Dual Pedagogy in iQuanta CAT Classes">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<div class="why-iquanta-modals why-iquanta-modals-small">
    <div class="modal" id="LRDIInception" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered px-2">
            <div class="modal-content">
                <div class="modal-body ">

                    <div class="modal-body-wrapper lrdi-body position-relative">
                        <div data-dismiss="modal" class="close-button position-absolute">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 28 28"
                                fill="none">
                                <circle cx="14" cy="14" r="14" fill="#F9F4DD" />
                                <path
                                    d="M15.4164 14.3884L20.0068 9.80475C20.144 9.66753 20.2211 9.48142 20.2211 9.28736C20.2211 9.0933 20.144 8.90719 20.0068 8.76997C19.8696 8.63275 19.6835 8.55566 19.4895 8.55566C19.2954 8.55566 19.1093 8.63275 18.9721 8.76997L14.389 13.3609L9.80586 8.76997C9.66866 8.63275 9.48257 8.55566 9.28853 8.55566C9.09449 8.55566 8.9084 8.63275 8.77119 8.76997C8.63399 8.90719 8.55691 9.0933 8.55691 9.28736C8.55691 9.48142 8.63399 9.66753 8.77119 9.80475L13.3616 14.3884L8.77119 18.972C8.7029 19.0397 8.64869 19.1203 8.6117 19.2091C8.57471 19.2979 8.55566 19.3932 8.55566 19.4894C8.55566 19.5856 8.57471 19.6808 8.6117 19.7696C8.64869 19.8584 8.7029 19.939 8.77119 20.0068C8.83893 20.0751 8.91952 20.1293 9.00831 20.1663C9.0971 20.2033 9.19234 20.2223 9.28853 20.2223C9.38472 20.2223 9.47995 20.2033 9.56875 20.1663C9.65754 20.1293 9.73812 20.0751 9.80586 20.0068L14.389 15.4159L18.9721 20.0068C19.0399 20.0751 19.1205 20.1293 19.2093 20.1663C19.298 20.2033 19.3933 20.2223 19.4895 20.2223C19.5857 20.2223 19.6809 20.2033 19.7697 20.1663C19.8585 20.1293 19.9391 20.0751 20.0068 20.0068C20.0751 19.939 20.1293 19.8584 20.1663 19.7696C20.2033 19.6808 20.2223 19.5856 20.2223 19.4894C20.2223 19.3932 20.2033 19.2979 20.1663 19.2091C20.1293 19.1203 20.0751 19.0397 20.0068 18.972L15.4164 14.3884Z"
                                    fill="#1E1515" />
                            </svg>
                        </div>
                        <div class="d-block d-sm-none mobile-text">
                            <span class="f-light ">iQuanta presents
                            </span>
                            <h2 class="mb-0 align-items-center mt-2">LRDI Inception</h2>
                        </div>
                        <div class="d-flex  gap-2">
                            <div class="modal-text modal-half modal-right">
                                <div class="d-none d-sm-block">
                                    <span class="f-light ">iQuanta presents

                                    </span>
                                    <h2 class="mb-0 align-items-center mt-2">LRDI Inception</h2>

                                </div>
                                <div class="modal-sub-text mt-4 pr-4">
                                    <p class="f-light text-justify">The LRDI Inception by iQuanta : 50 Mind Bending
                                        LRDI Sets Launched ❤ In this initiative we planned to make Some Quality CAT
                                        Level LRDI Sets for you guys.. out of which 50 LRDI Videos are Launched.
                                    </p>
                                    <p class="f-light text-justify">
                                        We have explained CAT Level LRDI Sets on relevant topics in very detailed
                                        manner so that you are able to approach any type of Sets they ask in your
                                        CAT 2024 Exam.
                                    </p>
                                    <p class="f-light text-justify">
                                        You will find it in your dashboard at iQuanta website :)
                                    </p>
                                    <p class="f-light text-justify">Do check them out and Leave reviews if you like
                                        it.. took us 2 Months to create them as in parallel your Classes and mocks
                                        were also going on <3 </p>
                                            <p class="f-light text-justify">I hope you guys like them.
                                            </p>
                                </div>
                            </div>
                            <div class="modal-text modal-half modal-right pl-4 pr-3 position-relative">
                                <div class="d-flex flex-wrap gap-3 justify-content-end" style="gap: 1.4rem;">
                                    <div class="img">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/home-image/lrdi-inception-1.webp"
                                            alt="LRDI Inception">

                                    </div>
                                    <div class="img">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/home-image/lrdi-inception-2.webp"
                                            alt="LRDI Inception">

                                    </div>
                                </div>
                                <!-- <div class="founder-sign position-absolute">
                                    <h4 class="f-bold">Indrajeet Singh</h4>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="why-iquanta-modals why-iquanta-modals-lg">
    <div class="modal" id="StarMentors" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered px-2">
            <div class="modal-content">

                <div class="modal-body">
                    <div class="modal-header-card mb-3 position-relative">
                        <h2 class="d-flex align-items-center">Star Mentors</h2>
                        <p class="f-light ">Know about the top CAT mentors at iQuanta CAT coaching. We have the best
                            mentors at iQuanta to help the students with the CAT preparation such as</p>
                        <div data-dismiss="modal" class="close-button position-absolute">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 28 28"
                                fill="none">
                                <circle cx="14" cy="14" r="14" fill="#F9F4DD" />
                                <path
                                    d="M15.4164 14.3884L20.0068 9.80475C20.144 9.66753 20.2211 9.48142 20.2211 9.28736C20.2211 9.0933 20.144 8.90719 20.0068 8.76997C19.8696 8.63275 19.6835 8.55566 19.4895 8.55566C19.2954 8.55566 19.1093 8.63275 18.9721 8.76997L14.389 13.3609L9.80586 8.76997C9.66866 8.63275 9.48257 8.55566 9.28853 8.55566C9.09449 8.55566 8.9084 8.63275 8.77119 8.76997C8.63399 8.90719 8.55691 9.0933 8.55691 9.28736C8.55691 9.48142 8.63399 9.66753 8.77119 9.80475L13.3616 14.3884L8.77119 18.972C8.7029 19.0397 8.64869 19.1203 8.6117 19.2091C8.57471 19.2979 8.55566 19.3932 8.55566 19.4894C8.55566 19.5856 8.57471 19.6808 8.6117 19.7696C8.64869 19.8584 8.7029 19.939 8.77119 20.0068C8.83893 20.0751 8.91952 20.1293 9.00831 20.1663C9.0971 20.2033 9.19234 20.2223 9.28853 20.2223C9.38472 20.2223 9.47995 20.2033 9.56875 20.1663C9.65754 20.1293 9.73812 20.0751 9.80586 20.0068L14.389 15.4159L18.9721 20.0068C19.0399 20.0751 19.1205 20.1293 19.2093 20.1663C19.298 20.2033 19.3933 20.2223 19.4895 20.2223C19.5857 20.2223 19.6809 20.2033 19.7697 20.1663C19.8585 20.1293 19.9391 20.0751 20.0068 20.0068C20.0751 19.939 20.1293 19.8584 20.1663 19.7696C20.2033 19.6808 20.2223 19.5856 20.2223 19.4894C20.2223 19.3932 20.2033 19.2979 20.1663 19.2091C20.1293 19.1203 20.0751 19.0397 20.0068 18.972L15.4164 14.3884Z"
                                    fill="#1E1515" />
                            </svg>
                        </div>
                    </div>
                    <div class="modal-body-wrapper">
                        <div>
                            <p class="f-light mb-0 text-justify">Indrajeet Singh (Founder & CEO)</p>
                            <p class="f-light mb-0 text-justify">Raj Kumar Jha (6 times CAT QA 100%iler and 2 times
                                XAT 99.99%iler)</p>
                            <p class="f-light mb-0 text-justify">Vikrant Kathuria (VARC Master, VARC 100%iler & 100%
                                scorer)</p>
                            <p class="f-light mb-0 text-justify">Abhishek Leela Pandey (CAT 99.93%iler)</p>
                            <p class="f-light mb-0 text-justify">Kamal Lohia (CAT 99.99%iler)</p>
                            <!-- <p class="f-light mb-0 text-justify">Abbas Imran (CAT 99.7%iler)</p> -->
                            <p class="f-light mb-3 text-justify">Prashant Chadha (8 times CAT VARC 99%iler)</p>
                        </div>
                        <div class="d-flex flex-wrap gap-3">
                            <div class="modal-text modal-right">
                                <div class="d-flex flex-wrap gap-3">
                                    <div class="img">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/star-mentors-09-66e816f8e62dd.webp"
                                            alt="iQuanta Star Mentors">
                                    </div>
                                    <div class="img">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/star-mentors-02-66e816f86495c.webp"
                                            alt="iQuanta Star Mentors">
                                    </div>

                                    <div class="img ">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/star-mentors-07-66e816f59c53e.webp"
                                            alt="CAT Coaching">
                                    </div>
                                    <div class="img mt-2 ">
                                        <img loading="lazy" class="img-fluid "
                                            src="https://media.iquanta.in/ui_images/new-home/star-mentors-04-66e816f59655f.webp"
                                            alt="CAT Coaching">
                                    </div>
                                    <div class="img mt-2">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/star-mentors-06-66e816f263864.webp"
                                            alt="CAT Coaching">
                                    </div>

                                    <!-- <div class="img mt-2">
                                        <img loading="lazy"class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/star-mentors-03.jpeg" alt="CAT Coaching">
                                    </div> -->
                                    <div class="img mt-2 ">
                                        <img loading="lazy" class="img-fluid "
                                            src="https://media.iquanta.in/ui_images/new-home/star-mentors-08-66e816f243f5a.webp"
                                            alt="CAT Coaching">
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<div class="why-iquanta-modals why-iquanta-modals-lg">
    <div class="modal" id="CATMockModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered px-2">
            <div class="modal-content">

                <div class="modal-body">
                    <div class="modal-header-card mb-3 position-relative">
                        <h2 class="mb-0 d-flex align-items-center"><span class="f-light mr-4 d-none d-sm-block">iQuanta
                                Presents</span>iQuanta's iCAT Mocks</h2>
                        <div data-dismiss="modal" class="close-button position-absolute">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 28 28"
                                fill="none">
                                <circle cx="14" cy="14" r="14" fill="#F9F4DD" />
                                <path
                                    d="M15.4164 14.3884L20.0068 9.80475C20.144 9.66753 20.2211 9.48142 20.2211 9.28736C20.2211 9.0933 20.144 8.90719 20.0068 8.76997C19.8696 8.63275 19.6835 8.55566 19.4895 8.55566C19.2954 8.55566 19.1093 8.63275 18.9721 8.76997L14.389 13.3609L9.80586 8.76997C9.66866 8.63275 9.48257 8.55566 9.28853 8.55566C9.09449 8.55566 8.9084 8.63275 8.77119 8.76997C8.63399 8.90719 8.55691 9.0933 8.55691 9.28736C8.55691 9.48142 8.63399 9.66753 8.77119 9.80475L13.3616 14.3884L8.77119 18.972C8.7029 19.0397 8.64869 19.1203 8.6117 19.2091C8.57471 19.2979 8.55566 19.3932 8.55566 19.4894C8.55566 19.5856 8.57471 19.6808 8.6117 19.7696C8.64869 19.8584 8.7029 19.939 8.77119 20.0068C8.83893 20.0751 8.91952 20.1293 9.00831 20.1663C9.0971 20.2033 9.19234 20.2223 9.28853 20.2223C9.38472 20.2223 9.47995 20.2033 9.56875 20.1663C9.65754 20.1293 9.73812 20.0751 9.80586 20.0068L14.389 15.4159L18.9721 20.0068C19.0399 20.0751 19.1205 20.1293 19.2093 20.1663C19.298 20.2033 19.3933 20.2223 19.4895 20.2223C19.5857 20.2223 19.6809 20.2033 19.7697 20.1663C19.8585 20.1293 19.9391 20.0751 20.0068 20.0068C20.0751 19.939 20.1293 19.8584 20.1663 19.7696C20.2033 19.6808 20.2223 19.5856 20.2223 19.4894C20.2223 19.3932 20.2033 19.2979 20.1663 19.2091C20.1293 19.1203 20.0751 19.0397 20.0068 18.972L15.4164 14.3884Z"
                                    fill="#1E1515" />
                            </svg>
                        </div>
                    </div>
                    <div class="modal-body-wrapper">
                        <div class="modal-text modal-right">
                            <p class="f-light text-justify">iQuanta provides a comprehensive and AI based mock
                                platform known as the iCAT mocks. These mocks are based on actual CAT exam patterns
                                that provide detailed insights and performance analysis to help the aspirants ace
                                the CAT exam. The mock platform consists of 35 full mocks and 45 sectional tests
                                along with past year papers as mocks. Students will also get AI analysis and video
                                solutions. 35 full length mocks include 20 CAT full length proctored mocks and 15
                                CAT full length un proctored mocks. Students will get score vs percentile data based
                                on the level of the CAT hence they will get to predict their B-School. Aspirants can
                                also compare their current attempted mocks with previous attempted mocks.</p>
                        </div>
                        <div class="d-flex flex-wrap gap-3">
                            <div class="modal-text modal-right modal-img-two">
                                <div class="d-flex flex-wrap gap-3">
                                    <div class="img">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/error-tracker.webp"
                                            alt="CAT Coaching">
                                    </div>
                                    <div class="img">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/goal-tracker.webp"
                                            alt="CAT Coaching">
                                    </div>

                                    <div class="img mt-2 ">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/goal-setter.webp"
                                            alt="CAT Coaching">
                                    </div>
                                    <div class="img mt-2 ">
                                        <img loading="lazy" class="img-fluid "
                                            src="https://media.iquanta.in/ui_images/new-home/mock-tracker-1.webp"
                                            alt="CAT Coaching">
                                    </div>
                                    <div class="img mt-2">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/mock-tracker-2.webp"
                                            alt="CAT Coaching">
                                    </div>

                                    <div class="img mt-2">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/mock-tracker-3.webp"
                                            alt="CAT Coaching">
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<div class="why-iquanta-modals why-iquanta-modals-small">
    <div class="modal" id="CATToppers" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered px-2">
            <div class="modal-content">
                <div class="modal-body p-0">
                    <div class="modal-body-wrapper">
                        <div class="d-flex gap-3">
                            <div class="modal-text modal-right">
                                <div class="d-flex gap-3 justify-content-end" style="gap: 1.4rem;">
                                    <div class="img">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/home-image/topper-modal.webp"
                                            alt="CAT Coaching">
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="why-iquanta-modals why-iquanta-modals-lg">
    <div class="modal" id="DoubtSolving" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered px-2">
            <div class="modal-content">

                <div class="modal-body">
                    <div class="modal-header-card mb-3 position-relative">
                        <h2 class="d-flex align-items-center"><span class="f-light mr-4 d-none d-sm-block">iQuanta
                                Presents</span>24x7 Instant Doubt Solving by iQuanta</h2>
                        <div data-dismiss="modal" class="close-button position-absolute">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 28 28"
                                fill="none">
                                <circle cx="14" cy="14" r="14" fill="#F9F4DD" />
                                <path
                                    d="M15.4164 14.3884L20.0068 9.80475C20.144 9.66753 20.2211 9.48142 20.2211 9.28736C20.2211 9.0933 20.144 8.90719 20.0068 8.76997C19.8696 8.63275 19.6835 8.55566 19.4895 8.55566C19.2954 8.55566 19.1093 8.63275 18.9721 8.76997L14.389 13.3609L9.80586 8.76997C9.66866 8.63275 9.48257 8.55566 9.28853 8.55566C9.09449 8.55566 8.9084 8.63275 8.77119 8.76997C8.63399 8.90719 8.55691 9.0933 8.55691 9.28736C8.55691 9.48142 8.63399 9.66753 8.77119 9.80475L13.3616 14.3884L8.77119 18.972C8.7029 19.0397 8.64869 19.1203 8.6117 19.2091C8.57471 19.2979 8.55566 19.3932 8.55566 19.4894C8.55566 19.5856 8.57471 19.6808 8.6117 19.7696C8.64869 19.8584 8.7029 19.939 8.77119 20.0068C8.83893 20.0751 8.91952 20.1293 9.00831 20.1663C9.0971 20.2033 9.19234 20.2223 9.28853 20.2223C9.38472 20.2223 9.47995 20.2033 9.56875 20.1663C9.65754 20.1293 9.73812 20.0751 9.80586 20.0068L14.389 15.4159L18.9721 20.0068C19.0399 20.0751 19.1205 20.1293 19.2093 20.1663C19.298 20.2033 19.3933 20.2223 19.4895 20.2223C19.5857 20.2223 19.6809 20.2033 19.7697 20.1663C19.8585 20.1293 19.9391 20.0751 20.0068 20.0068C20.0751 19.939 20.1293 19.8584 20.1663 19.7696C20.2033 19.6808 20.2223 19.5856 20.2223 19.4894C20.2223 19.3932 20.2033 19.2979 20.1663 19.2091C20.1293 19.1203 20.0751 19.0397 20.0068 18.972L15.4164 14.3884Z"
                                    fill="#1E1515" />
                            </svg>
                        </div>
                    </div>
                    <div class="modal-body-wrapper">

                        <div class="d-flex flex-wrap gap-3">
                            <div class="modal-text modal-right">
                                <div class="d-flex flex-wrap gap-3">
                                    <div class="img img-med">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/doubt-5-66e8082aa2ef7.webp"
                                            alt="CAT Coaching">
                                    </div>
                                    <div class="img img-sm">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/doubt-6-66e8082a8fde3.webp"
                                            alt="CAT Coaching">
                                    </div>
                                </div>

                            </div>
                            <div class="modal-text modal-right">
                                <div>
                                    <p class="f-light mb-3 text-justify">The feature that iQuanta CAT online
                                        teaching is known for is the 24*7 instant doubt solving (within 15 mins).
                                        Paid students get their doubts cleared within 15 mins in secret groups.
                                        During the live classes also doubts will get solved within 20 seconds. The
                                        biggest problem that the candidates face after joining CAT coaching is doubt
                                        resolution. Every aspirant has an expectation that their doubts will be
                                        cleared immediately after they have raised it. Immediate doubt solving adds
                                        a greater advantage to the CAT preparation. Therefore, iQuanta CAT coaching
                                        provide free 24*7 instant doubt solving mechanisms on the Fb group of CAT
                                        preparation. Students get the options to clear their doubts in both textual
                                        as well as video formats.</p>
                                    <h5 class="f-bold mb-2">iQuanta 24x7 Instant Doubt Solving Features :
                                    </h5>
                                    <p class="f-light mb-3 text-justify">Not restricted to iQuanta material: The
                                        unique feature that you get on our community or any of our courses is that
                                        you need not hesitate before asking your questions from any material that
                                        you are practising from.
                                    </p>
                                    <p class="f-light mb-3 text-justify">In the Fb group, you can ask your doubts
                                        anytime either from the student community or from your mentors. This ensures
                                        that you are guided well as well as gain insight from your peers preparing
                                        for the exams just like you.
                                    </p>
                                    <p class="f-light mb-3 text-justify">24x7 doubt-solving in classes: If you are
                                        an enrolled student, you need not worry about specific time slots or wait
                                        for the class to get over to ask your doubts. You can get your doubts
                                        cleared even during the class, as and when they arise, and the teachers will
                                        be ready to help.
                                    </p>
                                </div>
                            </div>

                            <div class="modal-text modal-right">
                                <div class="gallery-div d-flex flex-wrap gap-3">
                                    <div class="img d-flex flex-wrap gap-3">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/doubt-6-66e8082a8fde3.webp"
                                            alt="CAT Coaching">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/doubt-10-66e80ab8a4731.webp"
                                            alt="CAT Coaching">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/247-doubts-66e80ab6f03c3.webp"
                                            alt="CAT Coaching">
                                    </div>

                                    <div class="img d-flex flex-wrap gap-3">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/doubt-8.webp" alt="CAT Coaching">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/doubt-7-66e80ab496b13.webp"
                                            alt="CAT Coaching">
                                    </div>

                                    <div class="img d-flex flex-wrap gap-3">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/doubt-9-66e80ab486f19.webp"
                                            alt="CAT Coaching">
                                        <img loading="lazy" class="img-fluid"
                                            src="https://media.iquanta.in/ui_images/new-home/whatsapp-image-2023-04-30-at-103840-pm-66e80ab797155.webp"
                                            alt="CAT Coaching">
                                    </div>

                                </div>
                            </div>
                            <div class="modal-text modal-right">
                                <div>
                                    <h5 class="f-bold mb-2">The three-step process to doubt-solving:
                                    </h5>
                                    <p class="f-light mb-3 text-justify">In the class, you will be provided with
                                        three different options to have your doubts cleared. Giving an example: in
                                        the class, after you have been provided with questions to practice, you will
                                        be provided with detailed solutions in both textual and video format.
                                    </p>
                                    <p class="f-light mb-3 text-justify">Textual format, for example, can be used if
                                        you are stuck at a certain part of the question. The video format can be
                                        used for a detailed solution.</p>
                                    <p class="f-light mb-3 text-justify">There’s also a third option, if you still
                                        have doubts even after watching the video, you can directly ask your teacher
                                        to get it resolved on the spot. This ensures that you are not left out in
                                        the class and are able to maintain pace with other students. </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<div class="why-iquanta-modals get-counselling-form">
    <div class="modal" id="ChooseEquiry" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered px-2">
            <div class="modal-content  p-2">
                <div class="modal-body p-0">
                    <div data-dismiss="modal" class="close-button position-absolute">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 28 28" fill="none">
                            <circle cx="14" cy="14" r="14" fill="#F9F4DD" />
                            <path
                                d="M15.4164 14.3884L20.0068 9.80475C20.144 9.66753 20.2211 9.48142 20.2211 9.28736C20.2211 9.0933 20.144 8.90719 20.0068 8.76997C19.8696 8.63275 19.6835 8.55566 19.4895 8.55566C19.2954 8.55566 19.1093 8.63275 18.9721 8.76997L14.389 13.3609L9.80586 8.76997C9.66866 8.63275 9.48257 8.55566 9.28853 8.55566C9.09449 8.55566 8.9084 8.63275 8.77119 8.76997C8.63399 8.90719 8.55691 9.0933 8.55691 9.28736C8.55691 9.48142 8.63399 9.66753 8.77119 9.80475L13.3616 14.3884L8.77119 18.972C8.7029 19.0397 8.64869 19.1203 8.6117 19.2091C8.57471 19.2979 8.55566 19.3932 8.55566 19.4894C8.55566 19.5856 8.57471 19.6808 8.6117 19.7696C8.64869 19.8584 8.7029 19.939 8.77119 20.0068C8.83893 20.0751 8.91952 20.1293 9.00831 20.1663C9.0971 20.2033 9.19234 20.2223 9.28853 20.2223C9.38472 20.2223 9.47995 20.2033 9.56875 20.1663C9.65754 20.1293 9.73812 20.0751 9.80586 20.0068L14.389 15.4159L18.9721 20.0068C19.0399 20.0751 19.1205 20.1293 19.2093 20.1663C19.298 20.2033 19.3933 20.2223 19.4895 20.2223C19.5857 20.2223 19.6809 20.2033 19.7697 20.1663C19.8585 20.1293 19.9391 20.0751 20.0068 20.0068C20.0751 19.939 20.1293 19.8584 20.1663 19.7696C20.2033 19.6808 20.2223 19.5856 20.2223 19.4894C20.2223 19.3932 20.2033 19.2979 20.1663 19.2091C20.1293 19.1203 20.0751 19.0397 20.0068 18.972L15.4164 14.3884Z"
                                fill="#1E1515" />
                        </svg>
                    </div>
                    <div class="modal-body-wrapper">
                        <div class="d-flex gap-2">

                            <div class="counselling-form px-2 py-3">
                                <div class="text-center mb-3">
                                    <h5 class="f-medium mb-2">Get counselling & free resources</h5>
                                    <h6 class="mb-0 f-light">Select your Exams</h6>
                                </div>

                                <div class="course-items p-3 mb-2 d-flex flex-wrap gap-2 justify-content-center">
                                    <div (click)="selectCat('CAT')"
                                        class="course-single-item  d-flex align-items-center p-md-2 f-medium"
                                        [ngClass]="{'active': callBackForm.value.course.includes('CAT') }">
                                        CAT
                                        <span
                                            class="ml-2 rounded-circle d-flex align-items-center justify-content-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9"
                                                viewBox="0 0 14 10" fill="none">
                                                <path
                                                    d="M1 5.61364L4.4689 8.94779C4.54137 9.01734 4.6588 9.01746 4.73128 8.94779L13 1"
                                                    stroke="#F9F4DD" stroke-width="1.7" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                            </svg>
                                        </span>
                                    </div>

                                    <div (click)="selectCat('JEE Main')"
                                        class="course-single-item  d-flex align-items-center p-md-2 f-medium"
                                        [ngClass]="{'active': callBackForm.value.course.includes('JEE Main') }">
                                        JEE Main
                                        <span
                                            class="ml-2 rounded-circle d-flex align-items-center justify-content-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10"
                                                viewBox="0 0 14 10" fill="none">
                                                <path
                                                    d="M1 5.61364L4.4689 8.94779C4.54137 9.01734 4.6588 9.01746 4.73128 8.94779L13 1"
                                                    stroke="#F9F4DD" stroke-width="1.7" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                            </svg>
                                        </span>
                                    </div>

                                    <div (click)="selectCat('JEE Advance')"
                                        class="course-single-item  d-flex align-items-center p-md-2 f-medium"
                                        [ngClass]="{'active': callBackForm.value.course.includes('JEE Advance') }">
                                        JEE Advance
                                        <span
                                            class="ml-2 rounded-circle d-flex align-items-center justify-content-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10"
                                                viewBox="0 0 14 10" fill="none">
                                                <path
                                                    d="M1 5.61364L4.4689 8.94779C4.54137 9.01734 4.6588 9.01746 4.73128 8.94779L13 1"
                                                    stroke="#F9F4DD" stroke-width="1.7" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                            </svg>
                                        </span>
                                    </div>

                                    <div (click)="selectCat('IPMAT')"
                                        class="course-single-item  d-flex align-items-center p-md-2 f-medium"
                                        [ngClass]="{'active': callBackForm.value.course.includes('IPMAT') }">
                                        IPMAT
                                        <span
                                            class="ml-2 rounded-circle d-flex align-items-center justify-content-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10"
                                                viewBox="0 0 14 10" fill="none">
                                                <path
                                                    d="M1 5.61364L4.4689 8.94779C4.54137 9.01734 4.6588 9.01746 4.73128 8.94779L13 1"
                                                    stroke="#F9F4DD" stroke-width="1.7" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                            </svg>
                                        </span>
                                    </div>

                                    <div (click)="selectCat('NEET')"
                                        class="course-single-item  d-flex align-items-center p-md-2 f-medium"
                                        [ngClass]="{'active': callBackForm.value.course.includes('NEET') }">
                                        NEET
                                        <span
                                            class="ml-2 rounded-circle d-flex align-items-center justify-content-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10"
                                                viewBox="0 0 14 10" fill="none">
                                                <path
                                                    d="M1 5.61364L4.4689 8.94779C4.54137 9.01734 4.6588 9.01746 4.73128 8.94779L13 1"
                                                    stroke="#F9F4DD" stroke-width="1.7" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                            </svg>
                                        </span>
                                    </div>

                                    <div (click)="selectCat('GMAT')"
                                        class="course-single-item  d-flex align-items-center p-md-2 f-medium"
                                        [ngClass]="{'active': callBackForm.value.course.includes('GMAT') }">
                                        GMAT
                                        <span
                                            class="ml-2 rounded-circle d-flex align-items-center justify-content-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10"
                                                viewBox="0 0 14 10" fill="none">
                                                <path
                                                    d="M1 5.61364L4.4689 8.94779C4.54137 9.01734 4.6588 9.01746 4.73128 8.94779L13 1"
                                                    stroke="#F9F4DD" stroke-width="1.7" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                            </svg>
                                        </span>
                                    </div>

                                    <div (click)="selectCat('XAT')"
                                        class="course-single-item  d-flex align-items-center p-md-2 f-medium"
                                        [ngClass]="{'active': callBackForm.value.course.includes('XAT') }">
                                        XAT
                                        <span
                                            class="ml-2 rounded-circle d-flex align-items-center justify-content-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10"
                                                viewBox="0 0 14 10" fill="none">
                                                <path
                                                    d="M1 5.61364L4.4689 8.94779C4.54137 9.01734 4.6588 9.01746 4.73128 8.94779L13 1"
                                                    stroke="#F9F4DD" stroke-width="1.7" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                            </svg>
                                        </span>
                                    </div>

                                    <div (click)="selectCat('CMAT')"
                                        class="course-single-item  d-flex align-items-center p-md-2 f-medium"
                                        [ngClass]="{'active': callBackForm.value.course.includes('CMAT') }">
                                        CMAT
                                        <span
                                            class="ml-2 rounded-circle d-flex align-items-center justify-content-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10"
                                                viewBox="0 0 14 10" fill="none">
                                                <path
                                                    d="M1 5.61364L4.4689 8.94779C4.54137 9.01734 4.6588 9.01746 4.73128 8.94779L13 1"
                                                    stroke="#F9F4DD" stroke-width="1.7" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                            </svg>
                                        </span>
                                    </div>

                                    <div (click)="selectCat('MICAT')"
                                        class="course-single-item  d-flex align-items-center p-md-2 f-medium"
                                        [ngClass]="{'active': callBackForm.value.course.includes('MICAT') }">
                                        MICAT
                                        <span
                                            class="ml-2 rounded-circle d-flex align-items-center justify-content-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10"
                                                viewBox="0 0 14 10" fill="none">
                                                <path
                                                    d="M1 5.61364L4.4689 8.94779C4.54137 9.01734 4.6588 9.01746 4.73128 8.94779L13 1"
                                                    stroke="#F9F4DD" stroke-width="1.7" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                            </svg>
                                        </span>
                                    </div>

                                    <div (click)="selectCat('CUET UG')"
                                        class="course-single-item  d-flex align-items-center p-md-2 f-medium "
                                        [ngClass]="{'active': callBackForm.value.course.includes('CUET UG') }">
                                        CUET UG
                                        <span
                                            class="ml-2 rounded-circle d-flex align-items-center justify-content-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10"
                                                viewBox="0 0 14 10" fill="none">
                                                <path
                                                    d="M1 5.61364L4.4689 8.94779C4.54137 9.01734 4.6588 9.01746 4.73128 8.94779L13 1"
                                                    stroke="#F9F4DD" stroke-width="1.7" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                            </svg>
                                        </span>
                                    </div>

                                    <div (click)="selectCat('CUET PG')"
                                        class="course-single-item  d-flex align-items-center p-md-2 f-medium"
                                        [ngClass]="{'active': callBackForm.value.course.includes('CUET PG') }">
                                        CUET PG
                                        <span
                                            class="ml-2 rounded-circle d-flex align-items-center justify-content-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10"
                                                viewBox="0 0 14 10" fill="none">
                                                <path
                                                    d="M1 5.61364L4.4689 8.94779C4.54137 9.01734 4.6588 9.01746 4.73128 8.94779L13 1"
                                                    stroke="#F9F4DD" stroke-width="1.7" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                            </svg>
                                        </span>
                                    </div>



                                    <div (click)="selectCat('CLAT')"
                                        class="course-single-item  d-flex align-items-center p-md-2 f-medium"
                                        [ngClass]="{'active': callBackForm.value.course.includes('CLAT') }">
                                        CLAT
                                        <span
                                            class="ml-2 rounded-circle d-flex align-items-center justify-content-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10"
                                                viewBox="0 0 14 10" fill="none">
                                                <path
                                                    d="M1 5.61364L4.4689 8.94779C4.54137 9.01734 4.6588 9.01746 4.73128 8.94779L13 1"
                                                    stroke="#F9F4DD" stroke-width="1.7" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                            </svg>
                                        </span>
                                    </div>


                                </div>


                                <form class="p-3" [formGroup]="callBackForm">
                                    <div class="row">
                                        <div class="col-md-6 pr-sm-1">
                                            <div class="form-group">
                                                <label class="f-light mb-2 text-uppercase">Name</label>
                                                <input placeholder="Enter your name" formControlName="name" type="text"
                                                    class="form-control f-light">
                                            </div>
                                        </div>

                                        <div class="col-md-6 pl-sm-1">
                                            <div class="form-group">
                                                <label class="f-light mb-2 text-uppercase">Number</label>
                                                <input placeholder="Enter your number" type="text"
                                                    formControlName="phone" class="form-control">
                                            </div>
                                        </div>

                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label class="f-light mb-2 text-uppercase">Email</label>
                                                <input placeholder="Enter your email" type="text"
                                                    formControlName="email" class="form-control">
                                            </div>
                                        </div>

                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label class="f-light mb-2 text-uppercase">Exam year </label>
                                                <select formControlName="year" class="form-control"
                                                    id="exampleFormControlSelect1">
                                                    <option value="2025">2025</option>
                                                    <option value="2026">2026</option>
                                                    <option value="2027">2027</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="col-md-12">
                                            <div class="header-actions d-flex align-items-end h-100">
                                                <button (click)="courseEnquiry()"
                                                    class="btn d-flex align-item-center justify-content-center btn_bg text-uppercase w-100">Submit</button>
                                            </div>
                                        </div>
                                    </div>



                                </form>

                            </div>
                            <div class="mobile-card d-none d-sm-block py-4 px-4">
                                <img loading="lazy" class="img-fluid px-3"
                                    src="https://media.iquanta.in/ui_images/get-counselling-mobile.webp"
                                    alt="Get counselling & free resources">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row main-page">
    <div class="col-md-12">
        <div class="section-header d-flex align-item-center justify-content-between mb-4">
            <h2 class="mb-md-0">Why iQuanta is Best?</h2>

            <ng-container *ngIf="!hideButton">
                <div class="header-actions d-flex gap-2">
                    <button data-toggle="modal" data-target="#ChooseEquiry"
                        class="btn d-flex align-item-center full-text">Course Enquiry
                        <span class="ml-2 d-flex justify-content-center align-items-center rounded-circle">
                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 14 14"
                                fill="none">
                                <path d="M1 6.87948L12.7586 6.87948M6.87931 12.7588L6.87931 1.00017" stroke="white"
                                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </span>
                    </button>

                    <button (click)="gotosection('course-comparison')" class="btn d-flex align-item-center">iQuanta vs
                        Other
                        Coachings
                        <span class="ml-2 d-flex justify-content-center align-items-center rounded-circle">
                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 14 14"
                                fill="none">
                                <path d="M1 6.87948L12.7586 6.87948M6.87931 12.7588L6.87931 1.00017" stroke="white"
                                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </span>
                    </button>

                    <button data-toggle="modal" data-target="#CallsUsModal"
                        class="btn d-flex align-item-center justify-content-center icon-button p-0">
                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 26 26" fill="none">
                            <path
                                d="M25.9391 19.6242C25.6362 19.3015 24.5665 18.3474 22.6002 17.0851C20.6194 15.8118 19.1586 15.0178 18.7396 14.8327C18.7027 14.8163 18.662 14.8103 18.6219 14.8153C18.5818 14.8203 18.5439 14.8361 18.5121 14.8611C17.8371 15.3875 16.7008 16.3544 16.6398 16.4066C16.2463 16.7438 16.2463 16.7438 15.9242 16.6388C15.3578 16.4531 13.5981 15.5187 12.0647 13.9819C10.5314 12.445 9.54883 10.6418 9.36311 10.076C9.2569 9.75329 9.2569 9.75329 9.59526 9.3598C9.64749 9.29886 10.615 8.1625 11.1414 7.48812C11.1663 7.45636 11.1822 7.4184 11.1872 7.37831C11.1922 7.33823 11.1862 7.29754 11.1698 7.26061C10.9847 6.84101 10.1907 5.3808 8.91738 3.4C7.65333 1.4343 6.70036 0.364677 6.37767 0.0617248C6.34806 0.0337818 6.31146 0.0143431 6.27173 0.00545689C6.23199 -0.00342928 6.1906 -0.00143382 6.15191 0.0112328C5.02394 0.398852 3.93562 0.893449 2.90182 1.48827C1.90382 2.06842 0.958986 2.73553 0.0783066 3.48183C0.0475642 3.50797 0.0245158 3.54198 0.0116332 3.58022C-0.00124946 3.61846 -0.0034803 3.65948 0.00517974 3.69889C0.126478 4.26417 0.70627 6.62395 2.50542 9.89258C4.34114 13.2285 5.61332 14.9377 8.30915 17.6242C11.005 20.3108 12.7682 21.6595 16.1076 23.4953C19.3763 25.2944 21.7372 25.8748 22.3014 25.9949C22.3409 26.0035 22.3819 26.0012 22.4203 25.9883C22.4586 25.9755 22.4927 25.9525 22.519 25.9218C23.2652 25.0411 23.9321 24.0963 24.512 23.0983C25.1067 22.0644 25.6013 20.9761 25.989 19.8482C26.0014 19.8098 26.0034 19.7688 25.9946 19.7294C25.9858 19.69 25.9667 19.6537 25.9391 19.6242Z"
                                fill="black" />
                        </svg>
                    </button>
                    <button (click)="joinwhatsapp()"
                        class="btn d-flex align-item-center justify-content-center icon-button icon-button-stroke p-0">
                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" fill="#7AD06D"
                            class="bi bi-whatsapp" viewBox="0 0 16 16">
                            <path
                                d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
                        </svg>
                    </button>
                </div>
            </ng-container>

        </div>
    </div>

    <div class="col-md-12">
        <div class="iquanta-wrapper d-block d-sm-none">

            <div class="accordion" id="accordionExample2">
                <div class="card">
                    <div class="card-header" id="headingOne">
                        <button class="btn btn-link btn-block text-left"
                            [ngClass]="{'collapsed': pageType == 'new-landing'}" type="button" data-toggle="collapse"
                            data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                            <div class="d-flex align-items-center justify-content-between">

                                <div class="text">
                                    <h5 class="mb-0 f-bold mr-md-3">We work very hard on our CAT Content at iQuanta!
                                    </h5>
                                </div>
                                <span class="expand f-bold">Expand</span>
                            </div>
                        </button>
                    </div>

                    <div id="collapseOne" class="collapse " [ngClass]="{'show': pageType == 'new-landing'}"
                        aria-labelledby="headingOne" data-parent="#accordionExample2">
                        <div class="card-body">

                            <div class="material-tab-content position-relative ">
                                <div class="why-iquanta-item">
                                    <div class="para px-3 py-2 card_common">
                                        <!-- <h6 class="mb-2">We work very hard on our CAT Content at iQuanta! 
                                        </h6> -->
                                        <p class="mb-0 f-regular">20 Questions in CAT 2024 were DIRECTLY from iQuanta
                                            CAT Classes</p>
                                    </div>
                                    <div class="px-3 py-2 bg-white mt-2 img-sec card_common">
                                        <h6>Read CAT Aspirant's reviews just after CAT Exam</h6>
                                        <div class="img">
                                            <img loading="lazy" class="img-fluid" width="262" height="311"
                                                src="https://media.iquanta.in/ui_images/new-home/classrev.png"
                                                alt="CAT online coaching">
                                        </div>
                                        <button data-toggle="modal" data-target="#ClassFeedBack" class="btn w-100">View
                                            more</button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header" id="headingTwo">
                        <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse"
                            data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                            <div class="d-flex align-items-center justify-content-between">

                                <div class="text">
                                    <h5 class="mb-0 f-bold">Concept Clarity (via 7 Steps)</h5>
                                </div>
                                <span class="expand f-bold">Expand</span>
                            </div>
                        </button>
                    </div>
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                        data-parent="#accordionExample2">
                        <div class="card-body">
                            <div class="material-tab-content position-relative ">
                                <div class="why-iquanta-item ">
                                    <div class="para px-3 py-2 card_common">
                                        <h6 class="mb-0 f-regular"><span>iQuanta follows 7</span> step
                                            method to clear
                                            Concepts out of which 4 are Mentor driven & 3 Self as mentioned
                                            below:</h6>
                                    </div>

                                    <div class="qa-videos mt-2 position-relative card_common">
                                        <div
                                            class="step_no rounded-circle position-absolute bg-white text-dark d-flex justify-content-center f-bold align-items-center">
                                            1</div>
                                        <div class="d-flex text-center">
                                            <div class="px-2 py-2 qa-videos-in"
                                                style="border-right: 3px solid #2118181c;">
                                                <h6 class="text-white f-bold mb-2">Non Engineers QA Videos
                                                </h6>
                                                <button data-toggle="modal" data-target="#NonEngineersQAVideos"
                                                    class="btn mx-auto rounded-pill btn-sm d-flex align-item-center shadow-none border-0">Click
                                                    <span
                                                        class="ml-2 d-flex justify-content-center align-items-center rounded-circle">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9"
                                                            viewBox="0 0 14 14" fill="none">
                                                            <path
                                                                d="M1 6.87948L12.7586 6.87948M6.87931 12.7588L6.87931 1.00017"
                                                                stroke="white" stroke-width="2" stroke-linecap="round"
                                                                stroke-linejoin="round" />
                                                        </svg>
                                                    </span>
                                                </button>
                                            </div>
                                            <div class="px-2 py-2 qa-videos-in">
                                                <h6 class="text-white f-bold">Engineers VARC Conceptual</h6>
                                                <button data-toggle="modal" data-target="#VarcConceptualVideos"
                                                    class="btn mx-auto rounded-pill btn-sm d-flex align-item-center shadow-none border-0">Click
                                                    <span
                                                        class="ml-2 d-flex justify-content-center align-items-center rounded-circle">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9"
                                                            viewBox="0 0 14 14" fill="none">
                                                            <path
                                                                d="M1 6.87948L12.7586 6.87948M6.87931 12.7588L6.87931 1.00017"
                                                                stroke="white" stroke-width="2" stroke-linecap="round"
                                                                stroke-linejoin="round" />
                                                        </svg>
                                                    </span>
                                                </button>
                                            </div>

                                        </div>

                                        <div
                                            class="px-2 py-2 qa-videos-in d-flex align-item-center w-100 justify-content-center">
                                            <h6 class="text-white f-bold mb-0 mr-3">CAT LRDI Inception</h6>
                                            <button data-toggle="modal" data-target="#LRDIInception"
                                                class="btn rounded-pill btn-sm d-flex align-item-center shadow-none border-0">Click
                                                <span
                                                    class="ml-2 d-flex justify-content-center align-items-center rounded-circle">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9"
                                                        viewBox="0 0 14 14" fill="none">
                                                        <path
                                                            d="M1 6.87948L12.7586 6.87948M6.87931 12.7588L6.87931 1.00017"
                                                            stroke="white" stroke-width="2" stroke-linecap="round"
                                                            stroke-linejoin="round" />
                                                    </svg>
                                                </span>
                                            </button>
                                        </div>
                                    </div>

                                    <div
                                        class="qa-videos dual-pedagogy mt-3 position-relative p-1 shadow-none card_common">
                                        <div
                                            class="step_no rounded-circle position-absolute bg-white text-dark d-flex justify-content-center f-bold align-items-center">
                                            2</div>
                                        <div
                                            class="step_no step_no2 rounded-circle position-absolute bg-white text-dark d-flex justify-content-center f-bold align-items-center">
                                            3</div>
                                        <div class="d-flex text-center gap-1">
                                            <div class="live-cons d-flex align-items-center justify-content-center p-2">
                                                <svg class="mr-1 pr-1" xmlns="http://www.w3.org/2000/svg" width="16"
                                                    height="16" viewBox="0 0 21 15" fill="none">
                                                    <path
                                                        d="M19.6023 3.03493C19.4997 2.63586 19.2907 2.27021 18.9966 1.97492C18.7024 1.67963 18.3334 1.46516 17.9269 1.35317C16.4415 1 10.5 1 10.5 1C10.5 1 4.55849 1 3.07311 1.3868C2.66657 1.4988 2.29759 1.71327 2.00342 2.00856C1.70926 2.30384 1.50033 2.66949 1.39775 3.06856C1.1259 4.53637 0.992925 6.02536 1.00049 7.51682C0.990804 9.01951 1.12379 10.5199 1.39775 11.9987C1.51084 12.3854 1.72445 12.7371 2.01793 13.0199C2.31141 13.3028 2.67484 13.5071 3.07311 13.6132C4.55849 14 10.5 14 10.5 14C10.5 14 16.4415 14 17.9269 13.6132C18.3334 13.5012 18.7024 13.2867 18.9966 12.9914C19.2907 12.6962 19.4997 12.3305 19.6023 11.9314C19.872 10.4747 20.005 8.99705 19.9995 7.51682C20.0092 6.01413 19.8762 4.51378 19.6023 3.03493Z"
                                                        stroke="#F9F4DD" stroke-width="2" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                    <path d="M8.55692 10.2665L13.5226 7.51682L8.55692 4.76714V10.2665Z"
                                                        stroke="#F9F4DD" stroke-width="2" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                </svg>
                                                Live Conceptual
                                            </div>
                                            <div class="live-cons d-flex align-items-center justify-content-center p-2">
                                                <svg class="mr-1 pr-1" xmlns="http://www.w3.org/2000/svg" width="16"
                                                    height="16" viewBox="0 0 21 15" fill="none">
                                                    <path
                                                        d="M19.6023 3.03493C19.4997 2.63586 19.2907 2.27021 18.9966 1.97492C18.7024 1.67963 18.3334 1.46516 17.9269 1.35317C16.4415 1 10.5 1 10.5 1C10.5 1 4.55849 1 3.07311 1.3868C2.66657 1.4988 2.29759 1.71327 2.00342 2.00856C1.70926 2.30384 1.50033 2.66949 1.39775 3.06856C1.1259 4.53637 0.992925 6.02536 1.00049 7.51682C0.990804 9.01951 1.12379 10.5199 1.39775 11.9987C1.51084 12.3854 1.72445 12.7371 2.01793 13.0199C2.31141 13.3028 2.67484 13.5071 3.07311 13.6132C4.55849 14 10.5 14 10.5 14C10.5 14 16.4415 14 17.9269 13.6132C18.3334 13.5012 18.7024 13.2867 18.9966 12.9914C19.2907 12.6962 19.4997 12.3305 19.6023 11.9314C19.872 10.4747 20.005 8.99705 19.9995 7.51682C20.0092 6.01413 19.8762 4.51378 19.6023 3.03493Z"
                                                        stroke="#F9F4DD" stroke-width="2" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                    <path d="M8.55692 10.2665L13.5226 7.51682L8.55692 4.76714V10.2665Z"
                                                        stroke="#F9F4DD" stroke-width="2" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                </svg>
                                                Live Application
                                            </div>

                                        </div>

                                        <div class="text p-2 d-flex ">
                                            <div class="pr-4 mr-2">
                                                <h6 class="text-white mb-1">iQuanta’s Dual Pedagogy </h6>
                                                <p class="mb-0 f-light">Unique dual teaching method which
                                                    makes sure that
                                                    not only your concepts are clear but you can also apply
                                                    those concepts
                                                    in questions</p>
                                            </div>

                                            <button data-toggle="modal" data-target="#DualPedagogy"
                                                class="btn position-absolute rounded-pill btn-sm d-flex align-item-center shadow-none border-0">Click
                                                <span
                                                    class="ml-2 d-flex justify-content-center align-items-center rounded-circle">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9"
                                                        viewBox="0 0 14 14" fill="none">
                                                        <path
                                                            d="M1 6.87948L12.7586 6.87948M6.87931 12.7588L6.87931 1.00017"
                                                            stroke="white" stroke-width="2" stroke-linecap="round"
                                                            stroke-linejoin="round" />
                                                    </svg>
                                                </span>
                                            </button>
                                        </div>


                                    </div>

                                    <div class="mt-3 position-relative">

                                        <div class="d-flex text-center cols_2 gap-1">
                                            <div class="px-2 py-2 qa-videos-in qa-videos position-relative card_common">
                                                <div
                                                    class="step_no rounded-circle position-absolute bg-white text-dark d-flex justify-content-center f-bold align-items-center">
                                                    4</div>
                                                <h6 class="text-white f-bold mb-3">Dashboard Assignments
                                                </h6>
                                                <div class="img position-absolute mx-auto">
                                                    <img loading="lazy" class="img-fluid"
                                                        src="https://media.iquanta.in/ui_images/home-image/db-assign.png"
                                                        alt="CAT Coaching">
                                                </div>
                                                <button data-toggle="modal" data-target="#DashboardAssignments"
                                                    class="btn mx-auto rounded-pill btn-sm d-flex align-item-center shadow-none border-0 position-relative">Click
                                                    <span
                                                        class="ml-2 d-flex justify-content-center align-items-center rounded-circle">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9"
                                                            viewBox="0 0 14 14" fill="none">
                                                            <path
                                                                d="M1 6.87948L12.7586 6.87948M6.87931 12.7588L6.87931 1.00017"
                                                                stroke="white" stroke-width="2" stroke-linecap="round"
                                                                stroke-linejoin="round" />
                                                        </svg>
                                                    </span>
                                                </button>
                                            </div>
                                            <div class="px-2 py-2 qa-videos-in qa-videos text-left card_common">
                                                <h6 class="text-white f-bold mb-1">+3 Steps</h6>
                                                <p class="mb-0 f-regular">Mentor Driven Practice
                                                    Self Practice
                                                    Marathon Sessions</p>
                                                <button data-toggle="modal" data-target="#ThreeSteps"
                                                    class="btn ml-auto rounded-pill btn-sm d-flex align-item-center shadow-none border-0 position-relative">Click
                                                    <span
                                                        class="ml-2 d-flex justify-content-center align-items-center rounded-circle">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9"
                                                            viewBox="0 0 14 14" fill="none">
                                                            <path
                                                                d="M1 6.87948L12.7586 6.87948M6.87931 12.7588L6.87931 1.00017"
                                                                stroke="white" stroke-width="2" stroke-linecap="round"
                                                                stroke-linejoin="round" />
                                                        </svg>
                                                    </span>
                                                </button>
                                            </div>

                                        </div>


                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header" id="headingThree">
                        <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse"
                            data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                            <div class="d-flex align-items-center justify-content-between">
                                <div class="text">
                                    <h5 class="mb-0 f-bold">24*7 Doubt Solving (within 15 mins)</h5>
                                </div>
                                <span class="expand f-bold">Expand</span>
                            </div>
                        </button>
                    </div>
                    <div id="collapseThree" class="collapse show" aria-labelledby="headingThree"
                        data-parent="#accordionExample2">
                        <div class="card-body">
                            <div class="material-tab-content position-relative ">
                                <div class="why-iquanta-item">
                                    <div class="para px-3 py-2 card_common">
                                        <p class="mb-0 f-regular p-small">This is the most famous feature of
                                            iQuanta as
                                            iQuanta solves doubts within 15 mins in secret group for paid
                                            students be it day
                                            or night. During Live class also doubts get solved within 20
                                            seconds.</p>
                                    </div>

                                    <div class="how-fast-we-are p-3 mt-2 position-relative overflow-hidden card_common">
                                        <div class="img-globe position-absolute">
                                            <img loading="lazy"
                                                src="https://media.iquanta.in/ui_images/new-home/sun-new.gif"
                                                fetchpriority="low" alt="CAT Coaching">
                                        </div>
                                        <div class="img-globe moon position-absolute">
                                            <img loading="lazy"
                                                src="https://media.iquanta.in/ui_images/new-home/eartn-new.gif"
                                                fetchpriority="low" alt="CAT Coaching">
                                        </div>
                                        <div class="pl-5 ml-4">
                                            <h3 class="mb-1">How Fast are we?</h3>
                                            <p class="mb-0 f-light">8 minutes and 20 seconds</p>
                                            <div class="img arrow position-relative">
                                                <img loading="lazy" class="img-fluid"
                                                    src="https://media.iquanta.in/ui_images/home-image/arrow-up.png"
                                                    alt="CAT Coaching">
                                            </div>
                                        </div>

                                    </div>
                                    <div class="student-says-doubt-solving p-3 pb-4 card_common mt-2">
                                        <h3 class="mb-3 text-white">What students say about our lightning
                                            fast Doubt
                                            Solving!</h3>
                                        <div class="img p-2 card_common position-relative">
                                            <img loading="lazy" class="img-fluid"
                                                src="https://media.iquanta.in/ui_images/new-home/feedback-screen.webp"
                                                alt="What students say about our lightning fast Doubt Solving">
                                            <button data-toggle="modal" data-target="#DoubtSolving"
                                                class="btn rounded-pill btn-sm d-flex align-item-center shadow-none border-0 position-absolute">View
                                                More
                                                <span
                                                    class="ml-2 d-flex justify-content-center align-items-center rounded-circle">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9"
                                                        viewBox="0 0 14 14" fill="none">
                                                        <path
                                                            d="M1 6.87948L12.7586 6.87948M6.87931 12.7588L6.87931 1.00017"
                                                            stroke="white" stroke-width="2" stroke-linecap="round"
                                                            stroke-linejoin="round" />
                                                    </svg>
                                                </span>
                                            </button>
                                        </div>

                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-header" id="headingFour">
                        <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse"
                            data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                            <div class="d-flex align-items-center justify-content-between">
                                <div class="text">
                                    <h5 class="mb-0 f-bold">Rigorous Practice</h5>
                                </div>
                                <span class="expand f-bold">Expand</span>
                            </div>
                        </button>
                    </div>
                    <div id="collapseFour" class="collapse" [ngClass]="{'show': pageType == 'new-landing'}"
                        aria-labelledby="headingFour" data-parent="#accordionExample2">
                        <div class="card-body">
                            <div class="material-tab-content position-relative ">
                                <div class="why-iquanta-item">
                                    <div class="para px-3 py-2 card_common">
                                        <p class="mb-0 f-regular p-small">We don't just believe in
                                            conceptual clarity, we
                                            are constantly also making sure that you apply the concepts
                                            through our
                                            application classes, daily practice sessions, IIM ABC Material,
                                            books & mock
                                            tests.</p>
                                    </div>
                                    <div class="collapse-wrapper card_common mt-3">
                                        <div class="accordion" id="accordionExample3">
                                            <div class="card mb-2">
                                                <div class="card-header p-0 border-0 m-0" id="headingOne1">
                                                    <button class="btn btn-block text-left " type="button"
                                                        data-toggle="collapse" data-target="#collapseOne1"
                                                        aria-expanded="true" aria-controls="collapseOne1">
                                                        1. Topic wise Questions
                                                    </button>
                                                </div>

                                                <div id="collapseOne1" class="collapse show"
                                                    aria-labelledby="headingOne1" data-parent="#accordionExample3">
                                                    <div class="card-body">
                                                        <p class="f-regular mb-0">Topic Wise Practice
                                                            questions in the form
                                                            of assignments available
                                                            on the Student Dashboard</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card mb-2">
                                                <div class="card-header p-0  border-0 m-0 " id="headingTwo2">
                                                    <button class="btn btn-block text-left collapsed" type="button"
                                                        data-toggle="collapse" data-target="#collapseTwo2"
                                                        aria-expanded="false" aria-controls="collapseTwo2">
                                                        2. Practice Sessions
                                                    </button>
                                                </div>
                                                <div id="collapseTwo2" class="collapse" aria-labelledby="headingTwo2"
                                                    data-parent="#accordionExample3">
                                                    <div class="card-body">
                                                        <p class="f-regular mb-0">Mentor driven Daily
                                                            Practice sessions
                                                            conducted in iQuanta secret
                                                            groups with solutions</p>

                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card mb-2">
                                                <div class="card-header p-0 border-0 m-0 " id="headingThree3">
                                                    <button class="btn btn-block text-left collapsed" type="button"
                                                        data-toggle="collapse" data-target="#collapseThree3"
                                                        aria-expanded="false" aria-controls="collapseThree3">
                                                        3. IIM ABC Practice Material
                                                    </button>
                                                </div>
                                                <div id="collapseThree3" class="collapse"
                                                    aria-labelledby="headingThree3" data-parent="#accordionExample3">
                                                    <div class="card-body">
                                                        <p class="f-regular mb-2">7500+ CAT Level Practice
                                                            Questions</p>
                                                        <ul class="nav d-block">
                                                            <li>
                                                                <!-- <img loading="lazy"src="https://media.iquanta.in/ui_images/new-home/check-price.png"
                                                                    alt="check icon"> -->
                                                                <i class="bi bi-check-circle-fill"></i> 2500+ Quant
                                                                Questions
                                                            </li>
                                                            <li class="mt-1">
                                                                <!-- <img loading="lazy"
                                                                    src="https://media.iquanta.in/ui_images/new-home/check-price.png"
                                                                    alt="check icon">  -->
                                                                <i class="bi bi-check-circle-fill"></i> 500+ RC Sets
                                                            </li>
                                                            <li class="mt-1">
                                                                <!-- <img loading="lazy"
                                                                    src="https://media.iquanta.in/ui_images/new-home/check-price.png"
                                                                    alt="check icon">  -->
                                                                <i class="bi bi-check-circle-fill"></i> 500+ LRDI Sets
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="cat-books card_common mt-2 p-2">
                                        <div class="d-flex align-items-center justify-content-between mb-2 px-2">
                                            <h5 class="mb-0 text-white">CAT Books</h5>
                                            <button data-toggle="modal" data-target="#CATBooks"
                                                class="btn rounded-pill btn-sm d-flex align-item-center shadow-none border-0">Click
                                                <span
                                                    class="ml-2 d-flex justify-content-center align-items-center rounded-circle">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9"
                                                        viewBox="0 0 14 14" fill="none">
                                                        <path
                                                            d="M1 6.87948L12.7586 6.87948M6.87931 12.7588L6.87931 1.00017"
                                                            stroke="white" stroke-width="2" stroke-linecap="round"
                                                            stroke-linejoin="round" />
                                                    </svg>
                                                </span>
                                            </button>
                                        </div>
                                        <div class="img">
                                            <img loading="lazy" class="img-fluid" width="278" height="93"
                                                src="https://media.iquanta.in/ui_images/boooks.webp" alt="CAT Coaching">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="why-iquanta-bellow p-4">
                <div class="row">
                    <div class="col-md-6 pr-0">
                        <div class="error-tracker ">
                            <div class="error-tracker-graph px-2 pt-2 pb-2">
                                <div class="img">
                                    <img loading="lazy" class="img-fluid"
                                        src="https://media.iquanta.in/ui_images/home-image/error-track.svg"
                                        alt="CAT Coaching">
                                </div>
                            </div>
                            <div class="icat-mocks-card d-flex px-3 py-2 justify-content-between align-items-center">
                                <div class="text-card">
                                    <h6 class="f-light mb-2 text-white mt-1">iQuanta's iCAT Mocks</h6>
                                    <ul class="nav list_card d-flex flex-column text-white f-light p-0">
                                        <li class="d-flex align-items-center">
                                            <svg class="mr-2" xmlns="http://www.w3.org/2000/svg" width="13" height="13"
                                                viewBox="0 0 17 17" fill="none">
                                                <path
                                                    d="M5.125 8.5L7.375 10.75L11.875 6.25M16 8.5C16 12.6421 12.6421 16 8.5 16C4.35786 16 1 12.6421 1 8.5C1 4.35786 4.35786 1 8.5 1C12.6421 1 16 4.35786 16 8.5Z"
                                                    stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                            Shorten your analysis by 3 times with AI
                                        </li>
                                        <li class="d-flex align-items-center mt-1">
                                            <svg class="mr-2" xmlns="http://www.w3.org/2000/svg" width="13" height="13"
                                                viewBox="0 0 17 17" fill="none">
                                                <path
                                                    d="M5.125 8.5L7.375 10.75L11.875 6.25M16 8.5C16 12.6421 12.6421 16 8.5 16C4.35786 16 1 12.6421 1 8.5C1 4.35786 4.35786 1 8.5 1C12.6421 1 16 4.35786 16 8.5Z"
                                                    stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                            Video Solutions for all Full & Sectional Mocks
                                        </li>
                                        <li class="mr-1" class="d-flex align-items-center mt-1">
                                            <svg class="mr-2" xmlns="http://www.w3.org/2000/svg" width="13" height="13"
                                                viewBox="0 0 17 17" fill="none">
                                                <path
                                                    d="M5.125 8.5L7.375 10.75L11.875 6.25M16 8.5C16 12.6421 12.6421 16 8.5 16C4.35786 16 1 12.6421 1 8.5C1 4.35786 4.35786 1 8.5 1C12.6421 1 16 4.35786 16 8.5Z"
                                                    stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                            Error & Goal Tracker
                                        </li>
                                    </ul>
                                </div>
                                <div class="buttons-card text-center ">
                                    <div class="sec_mocks mb-3">35 Full Mocks</div>
                                    <div class="sec_mocks mb-2">45 Sectional Mocks</div>
                                    <button data-toggle="modal" data-target="#CATMockModal"
                                        class="btn btn-sm d-flex align-item-center justify-content-center">VIEW
                                        MORE
                                        <span
                                            class="ml-2 d-flex justify-content-center align-items-center rounded-circle">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9"
                                                viewBox="0 0 14 14" fill="none">
                                                <path d="M1 6.87948L12.7586 6.87948M6.87931 12.7588L6.87931 1.00017"
                                                    stroke="white" stroke-width="2" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                            </svg>
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6 pr-0">
                        <div class="d-flex flex-wrap gap-2">
                            <div class="star-mentor mt-2 pt-3 position-relative">
                                <div class="img pr-5">
                                    <img loading="lazy"
                                        src="https://media.iquanta.in/ui_images/home-image/mentors-image.webp"
                                        alt="CAT Coaching">
                                </div>
                                <div class="view-more-btn position-absolute">
                                    <button data-toggle="modal" data-target="#StarMentors"
                                        class="btn rounded-pill text-black f-medium">
                                        View More <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28"
                                            viewBox="0 0 37 37" fill="none">
                                            <path
                                                d="M18.5 1.00049C28.165 1.00049 36 8.8355 36 18.5005C36 28.1655 28.165 36.0005 18.5 36.0005C8.83502 36.0005 1 28.1655 1 18.5005C1 8.8355 8.83502 1.00049 18.5 1.00049Z"
                                                fill="#100703" />
                                            <path
                                                d="M18.5 1.00049L18.5 0.000488281L18.5 1.00049ZM18.5 36.0005L18.5 35.0005L18.5 36.0005ZM12 17.5005C11.4477 17.5005 11 17.9482 11 18.5005C11 19.0528 11.4477 19.5005 12 19.5005V17.5005ZM25 19.5005C25.5523 19.5005 26 19.0528 26 18.5005C26 17.9482 25.5523 17.5005 25 17.5005V19.5005ZM17.5 25.0005C17.5 25.5528 17.9477 26.0005 18.5 26.0005C19.0523 26.0005 19.5 25.5528 19.5 25.0005L17.5 25.0005ZM19.5 12.0005C19.5 11.4482 19.0523 11.0005 18.5 11.0005C17.9477 11.0005 17.5 11.4482 17.5 12.0005H19.5ZM18.5 2.00049C27.6127 2.00049 35 9.38779 35 18.5005L37 18.5005C37 8.28322 28.7173 0.000487834 18.5 0.000488281L18.5 2.00049ZM35 18.5005C35 27.6132 27.6127 35.0005 18.5 35.0005L18.5 37.0005C28.7173 37.0005 37 28.7178 37 18.5005L35 18.5005ZM18.5 35.0005C9.3873 35.0005 2 27.6132 2 18.5005L0 18.5005C4.45488e-07 28.7178 8.28273 37.0005 18.5 37.0005L18.5 35.0005ZM2 18.5005C2 9.38779 9.3873 2.00049 18.5 2.00049L18.5 0.000488281C8.28273 0.000488729 -4.45488e-07 8.28322 0 18.5005L2 18.5005ZM12 19.5005H18.5V17.5005H12V19.5005ZM18.5 19.5005H25V17.5005H18.5V19.5005ZM19.5 25.0005L19.5 18.5005L17.5 18.5005L17.5 25.0005L19.5 25.0005ZM19.5 18.5005V12.0005H17.5V18.5005H19.5Z"
                                                fill="white" />
                                        </svg></button>
                                </div>
                            </div>
                            <div class="star-mentor pt-2 position-relative">
                                <div class="img pr-4">
                                    <img loading="lazy" src="https://media.iquanta.in/ui_images/home-image/Result.webp"
                                        alt="CAT Coaching">
                                </div>
                                <div class="view-more-btn btn_ver position-absolute">
                                    <button data-toggle="modal" data-target="#CATToppers"
                                        class="btn rounded-pill text-black f-medium">
                                        View More <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28"
                                            viewBox="0 0 37 37" fill="none">
                                            <path
                                                d="M18.5 1.00049C28.165 1.00049 36 8.8355 36 18.5005C36 28.1655 28.165 36.0005 18.5 36.0005C8.83502 36.0005 1 28.1655 1 18.5005C1 8.8355 8.83502 1.00049 18.5 1.00049Z"
                                                fill="#100703" />
                                            <path
                                                d="M18.5 1.00049L18.5 0.000488281L18.5 1.00049ZM18.5 36.0005L18.5 35.0005L18.5 36.0005ZM12 17.5005C11.4477 17.5005 11 17.9482 11 18.5005C11 19.0528 11.4477 19.5005 12 19.5005V17.5005ZM25 19.5005C25.5523 19.5005 26 19.0528 26 18.5005C26 17.9482 25.5523 17.5005 25 17.5005V19.5005ZM17.5 25.0005C17.5 25.5528 17.9477 26.0005 18.5 26.0005C19.0523 26.0005 19.5 25.5528 19.5 25.0005L17.5 25.0005ZM19.5 12.0005C19.5 11.4482 19.0523 11.0005 18.5 11.0005C17.9477 11.0005 17.5 11.4482 17.5 12.0005H19.5ZM18.5 2.00049C27.6127 2.00049 35 9.38779 35 18.5005L37 18.5005C37 8.28322 28.7173 0.000487834 18.5 0.000488281L18.5 2.00049ZM35 18.5005C35 27.6132 27.6127 35.0005 18.5 35.0005L18.5 37.0005C28.7173 37.0005 37 28.7178 37 18.5005L35 18.5005ZM18.5 35.0005C9.3873 35.0005 2 27.6132 2 18.5005L0 18.5005C4.45488e-07 28.7178 8.28273 37.0005 18.5 37.0005L18.5 35.0005ZM2 18.5005C2 9.38779 9.3873 2.00049 18.5 2.00049L18.5 0.000488281C8.28273 0.000488729 -4.45488e-07 8.28322 0 18.5005L2 18.5005ZM12 19.5005H18.5V17.5005H12V19.5005ZM18.5 19.5005H25V17.5005H18.5V19.5005ZM19.5 25.0005L19.5 18.5005L17.5 18.5005L17.5 25.0005L19.5 25.0005ZM19.5 18.5005V12.0005H17.5V18.5005H19.5Z"
                                                fill="white" />
                                        </svg></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div class="iquanta-wrapper d-none d-sm-block">
            <div class="d-flex gap-3 p-4">
                <div class="why-iquanta-item">
                    <h3 class="why-iq-heading mb-3">Why iQuanta is Best?</h3>
                    <div class="para px-3 py-2 card_common">
                        <h6 class="mb-2">We work very hard on our CAT Content at iQuanta! </h6>
                        <p class="mb-0 f-regular">20 Questions in CAT 2024 were DIRECTLY from iQuanta CAT Classes</p>
                    </div>
                    <div class="px-3 py-2 bg-white mt-2 img-sec card_common">
                        <h6>Read CAT Aspirant's reviews just after CAT Exam</h6>
                        <div class="img">
                            <img loading="lazy" class="img-fluid"
                                src="https://media.iquanta.in/ui_images/new-home/classrev.png" width="261" height="309"
                                alt="CAT online coaching">
                        </div>
                        <button data-toggle="modal" data-target="#ClassFeedBack" class="btn w-100">View
                            more</button>
                    </div>
                </div>

                <div class="why-iquanta-item ">
                    <h3 class="why-iq-heading mb-3">Concept Clarity (via 7 Steps)</h3>
                    <div class="para px-3 py-2 card_common">
                        <h6 class="mb-0 f-regular"><span>iQuanta follows 7</span> step method to clear
                            Concepts out of which 4 are Mentor driven & 3 Self as mentioned below:</h6>
                    </div>

                    <div class="qa-videos mt-2 position-relative card_common">
                        <div
                            class="step_no rounded-circle position-absolute bg-white text-dark d-flex justify-content-center f-bold align-items-center">
                            1</div>
                        <div class="d-flex text-center">
                            <div class="px-2 py-2 qa-videos-in" style="border-right: 3px solid #2118181c;">
                                <h6 class="text-white f-bold mb-2">Non Engineers QA Videos </h6>
                                <button data-toggle="modal" data-target="#NonEngineersQAVideos"
                                    class="btn mx-auto rounded-pill btn-sm d-flex align-item-center shadow-none border-0">Click
                                    <span class="ml-2 d-flex justify-content-center align-items-center rounded-circle">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 14 14"
                                            fill="none">
                                            <path d="M1 6.87948L12.7586 6.87948M6.87931 12.7588L6.87931 1.00017"
                                                stroke="white" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                        </svg>
                                    </span>
                                </button>
                            </div>
                            <div class="px-2 py-2 qa-videos-in">
                                <h6 class="text-white f-bold">Engineers VARC Conceptual</h6>
                                <button data-toggle="modal" data-target="#VarcConceptualVideos"
                                    class="btn mx-auto rounded-pill btn-sm d-flex align-item-center shadow-none border-0">Click
                                    <span class="ml-2 d-flex justify-content-center align-items-center rounded-circle">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 14 14"
                                            fill="none">
                                            <path d="M1 6.87948L12.7586 6.87948M6.87931 12.7588L6.87931 1.00017"
                                                stroke="white" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                        </svg>
                                    </span>
                                </button>
                            </div>

                        </div>

                        <div class="px-2 py-2 qa-videos-in d-flex align-item-center w-100 justify-content-center">
                            <h6 class="text-white f-bold mb-0 mr-3">CAT LRDI Inception</h6>
                            <button data-toggle="modal" data-target="#LRDIInception"
                                class="btn rounded-pill btn-sm d-flex align-item-center shadow-none border-0">Click
                                <span class="ml-2 d-flex justify-content-center align-items-center rounded-circle">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 14 14"
                                        fill="none">
                                        <path d="M1 6.87948L12.7586 6.87948M6.87931 12.7588L6.87931 1.00017"
                                            stroke="white" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                </span>
                            </button>
                        </div>
                    </div>

                    <div class="qa-videos dual-pedagogy mt-3 position-relative p-1 shadow-none card_common">
                        <div
                            class="step_no rounded-circle position-absolute bg-white text-dark d-flex justify-content-center f-bold align-items-center">
                            2</div>
                        <div
                            class="step_no step_no2 rounded-circle position-absolute bg-white text-dark d-flex justify-content-center f-bold align-items-center">
                            3</div>
                        <div class="d-flex text-center gap-1">
                            <div class="live-cons d-flex align-items-center justify-content-center p-2">
                                <svg class="mr-1 pr-1" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                    viewBox="0 0 21 15" fill="none">
                                    <path
                                        d="M19.6023 3.03493C19.4997 2.63586 19.2907 2.27021 18.9966 1.97492C18.7024 1.67963 18.3334 1.46516 17.9269 1.35317C16.4415 1 10.5 1 10.5 1C10.5 1 4.55849 1 3.07311 1.3868C2.66657 1.4988 2.29759 1.71327 2.00342 2.00856C1.70926 2.30384 1.50033 2.66949 1.39775 3.06856C1.1259 4.53637 0.992925 6.02536 1.00049 7.51682C0.990804 9.01951 1.12379 10.5199 1.39775 11.9987C1.51084 12.3854 1.72445 12.7371 2.01793 13.0199C2.31141 13.3028 2.67484 13.5071 3.07311 13.6132C4.55849 14 10.5 14 10.5 14C10.5 14 16.4415 14 17.9269 13.6132C18.3334 13.5012 18.7024 13.2867 18.9966 12.9914C19.2907 12.6962 19.4997 12.3305 19.6023 11.9314C19.872 10.4747 20.005 8.99705 19.9995 7.51682C20.0092 6.01413 19.8762 4.51378 19.6023 3.03493Z"
                                        stroke="#F9F4DD" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M8.55692 10.2665L13.5226 7.51682L8.55692 4.76714V10.2665Z" stroke="#F9F4DD"
                                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                Live Conceptual
                            </div>
                            <div class="live-cons d-flex align-items-center justify-content-center p-2">
                                <svg class="mr-1 pr-1" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                    viewBox="0 0 21 15" fill="none">
                                    <path
                                        d="M19.6023 3.03493C19.4997 2.63586 19.2907 2.27021 18.9966 1.97492C18.7024 1.67963 18.3334 1.46516 17.9269 1.35317C16.4415 1 10.5 1 10.5 1C10.5 1 4.55849 1 3.07311 1.3868C2.66657 1.4988 2.29759 1.71327 2.00342 2.00856C1.70926 2.30384 1.50033 2.66949 1.39775 3.06856C1.1259 4.53637 0.992925 6.02536 1.00049 7.51682C0.990804 9.01951 1.12379 10.5199 1.39775 11.9987C1.51084 12.3854 1.72445 12.7371 2.01793 13.0199C2.31141 13.3028 2.67484 13.5071 3.07311 13.6132C4.55849 14 10.5 14 10.5 14C10.5 14 16.4415 14 17.9269 13.6132C18.3334 13.5012 18.7024 13.2867 18.9966 12.9914C19.2907 12.6962 19.4997 12.3305 19.6023 11.9314C19.872 10.4747 20.005 8.99705 19.9995 7.51682C20.0092 6.01413 19.8762 4.51378 19.6023 3.03493Z"
                                        stroke="#F9F4DD" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M8.55692 10.2665L13.5226 7.51682L8.55692 4.76714V10.2665Z" stroke="#F9F4DD"
                                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                Live Application
                            </div>

                        </div>

                        <div class="text p-2 d-flex ">
                            <div class="pr-4 mr-2">
                                <h6 class="text-white mb-1">iQuanta’s Dual Pedagogy </h6>
                                <p class="mb-0 f-light">Unique dual teaching method which makes sure that
                                    not only your concepts are clear but you can also apply those concepts
                                    in questions</p>
                            </div>

                            <button data-toggle="modal" data-target="#DualPedagogy"
                                class="btn position-absolute rounded-pill btn-sm d-flex align-item-center shadow-none border-0">Click
                                <span class="ml-2 d-flex justify-content-center align-items-center rounded-circle">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 14 14"
                                        fill="none">
                                        <path d="M1 6.87948L12.7586 6.87948M6.87931 12.7588L6.87931 1.00017"
                                            stroke="white" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                </span>
                            </button>
                        </div>


                    </div>

                    <div class="mt-3 position-relative">

                        <div class="d-flex text-center cols_2 gap-1">
                            <div class="px-2 py-2 qa-videos-in qa-videos position-relative card_common">
                                <div
                                    class="step_no rounded-circle position-absolute bg-white text-dark d-flex justify-content-center f-bold align-items-center">
                                    4</div>
                                <h6 class="text-white f-bold mb-3">Dashboard Assignments</h6>
                                <div class="img position-absolute mx-auto">
                                    <img loading="lazy" class="img-fluid"
                                        src="https://media.iquanta.in/ui_images/home-image/db-assign.png"
                                        alt="CAT Coaching">
                                </div>
                                <button data-toggle="modal" data-target="#DashboardAssignments"
                                    class="btn mx-auto rounded-pill btn-sm d-flex align-item-center shadow-none border-0 position-relative">Click
                                    <span class="ml-2 d-flex justify-content-center align-items-center rounded-circle">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 14 14"
                                            fill="none">
                                            <path d="M1 6.87948L12.7586 6.87948M6.87931 12.7588L6.87931 1.00017"
                                                stroke="white" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                        </svg>
                                    </span>
                                </button>
                            </div>
                            <div class="px-2 py-2 qa-videos-in qa-videos text-left card_common">
                                <h6 class="text-white f-bold mb-1">+3 Steps</h6>
                                <p class="mb-0 f-regular">Mentor Driven Practice
                                    Self Practice
                                    Marathon Sessions</p>
                                <button data-toggle="modal" data-target="#ThreeSteps"
                                    class="btn ml-auto rounded-pill btn-sm d-flex align-item-center shadow-none border-0 position-relative">Click
                                    <span class="ml-2 d-flex justify-content-center align-items-center rounded-circle">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 14 14"
                                            fill="none">
                                            <path d="M1 6.87948L12.7586 6.87948M6.87931 12.7588L6.87931 1.00017"
                                                stroke="white" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                        </svg>
                                    </span>
                                </button>
                            </div>

                        </div>


                    </div>

                </div>

                <div class="why-iquanta-item">
                    <h3 class="why-iq-heading mb-3">24*7 Doubt Solving (within 15 mins)</h3>
                    <div class="para px-3 py-2 card_common">
                        <p class="mb-0 f-regular p-small">This is the most famous feature of iQuanta as
                            iQuanta solves doubts within 15 mins in secret group for paid students be it day
                            or night. During Live class also doubts get solved within 20 seconds.</p>
                    </div>

                    <div class="how-fast-we-are p-3 mt-2 position-relative overflow-hidden card_common">
                        <div class="img-globe position-absolute">
                            <img loading="lazy" src="https://media.iquanta.in/ui_images/new-home/sun-new.gif"
                                alt="CAT Coaching" fetchpriority="low">
                        </div>
                        <div class="img-globe moon position-absolute">
                            <img loading="lazy" src="https://media.iquanta.in/ui_images/new-home/eartn-new.gif"
                                alt="CAT Coaching" fetchpriority="low">
                        </div>
                        <div class="pl-5 ml-4">
                            <h3 class="mb-1">How Fast are we?</h3>
                            <p class="mb-0 f-light">8 minutes and 20 seconds</p>
                            <div class="img arrow position-relative">
                                <img loading="lazy" class="img-fluid"
                                    src="https://media.iquanta.in/ui_images/home-image/arrow-up.png" alt="CAT Coaching">
                            </div>
                        </div>

                    </div>
                    <div class="student-says-doubt-solving p-3 pb-4 card_common mt-2">
                        <h3 class="mb-3 text-white">What students say about our lightning fast Doubt
                            Solving!</h3>
                        <div class="img p-2 card_common position-relative">
                            <img loading="lazy" class="img-fluid"
                                src="https://media.iquanta.in/ui_images/new-home/feedback-screen.webp"
                                alt="What students say about our lightning fast Doubt Solving">
                            <button data-toggle="modal" data-target="#DoubtSolving"
                                class="btn rounded-pill btn-sm d-flex align-item-center shadow-none border-0 position-absolute">View
                                More
                                <span class="ml-2 d-flex justify-content-center align-items-center rounded-circle">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 14 14"
                                        fill="none">
                                        <path d="M1 6.87948L12.7586 6.87948M6.87931 12.7588L6.87931 1.00017"
                                            stroke="white" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                </span>
                            </button>
                        </div>

                    </div>


                </div>

                <div class="why-iquanta-item">
                    <h3 class="why-iq-heading mb-3">Rigorous Practice</h3>
                    <div class="para px-3 py-2 card_common">
                        <p class="mb-0 f-regular p-small">We don't just believe in conceptual clarity, we
                            are constantly also making sure that you apply the concepts through our
                            application classes, daily practice sessions, IIM ABC Material, books & mock
                            tests.</p>
                    </div>
                    <div class="collapse-wrapper card_common mt-3">
                        <div class="accordion" id="accordionExample">
                            <div class="card mb-2">
                                <div class="card-header p-0 border-0 m-0" id="headingOne">
                                    <button class="btn btn-block text-left " type="button" data-toggle="collapse"
                                        data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                        1. Topic wise Questions
                                    </button>
                                </div>

                                <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                                    data-parent="#accordionExample">
                                    <div class="card-body">
                                        <p class="f-regular mb-0">Topic Wise Practice questions in the form
                                            of assignments available
                                            on the Student Dashboard</p>
                                    </div>
                                </div>
                            </div>
                            <div class="card mb-2">
                                <div class="card-header p-0  border-0 m-0 " id="headingTwo">
                                    <button class="btn btn-block text-left collapsed" type="button"
                                        data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false"
                                        aria-controls="collapseTwo">
                                        2. Practice Sessions
                                    </button>
                                </div>
                                <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo"
                                    data-parent="#accordionExample">
                                    <div class="card-body">
                                        <p class="f-regular mb-0">Mentor driven Daily Practice sessions
                                            conducted in iQuanta secret
                                            groups with solutions</p>

                                    </div>
                                </div>
                            </div>
                            <div class="card mb-2">
                                <div class="card-header p-0 border-0 m-0 " id="headingThree">
                                    <button class="btn btn-block text-left collapsed" type="button"
                                        data-toggle="collapse" data-target="#collapseThree" aria-expanded="false"
                                        aria-controls="collapseThree">
                                        3. IIM ABC Practice Material
                                    </button>
                                </div>
                                <div id="collapseThree" class="collapse" aria-labelledby="headingThree"
                                    data-parent="#accordionExample">
                                    <div class="card-body">
                                        <p class="f-regular mb-2">7500+ CAT Level Practice Questions</p>
                                        <ul class="nav d-block">
                                            <li>
                                                <i class="bi bi-check-circle-fill"></i> 2500+ Quant Questions
                                            </li>
                                            <li class="mt-1">
                                                <i class="bi bi-check-circle-fill"></i> 500+ RC Sets
                                            </li>
                                            <li class="mt-1">
                                                <i class="bi bi-check-circle-fill"></i> 500+ LRDI Sets
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="cat-books card_common mt-2 p-2">
                        <div class="d-flex align-items-center justify-content-between mb-2 px-2">
                            <h5 class="mb-0 text-white">CAT Books</h5>
                            <button data-toggle="modal" data-target="#CATBooks"
                                class="btn rounded-pill btn-sm d-flex align-item-center shadow-none border-0">Click
                                <span class="ml-2 d-flex justify-content-center align-items-center rounded-circle">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 14 14"
                                        fill="none">
                                        <path d="M1 6.87948L12.7586 6.87948M6.87931 12.7588L6.87931 1.00017"
                                            stroke="white" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                </span>
                            </button>
                        </div>
                        <div class="img">
                            <img loading="lazy" class="img-fluid" width="277" height="93"
                                src="https://media.iquanta.in/ui_images/boooks.webp" alt="CAT Coaching">
                        </div>
                    </div>
                </div>
            </div>

            <div class="why-iquanta-bellow p-4">
                <div class="row">
                    <div class="col-md-6 pr-0">
                        <div class="error-tracker d-flex">
                            <div class="error-tracker-graph px-2 pt-2 pb-0">
                                <div class="img">
                                    <img loading="lazy" class="img-fluid"
                                        src="https://media.iquanta.in/ui_images/home-image/error-track.svg"
                                        alt="CAT Coaching">
                                </div>
                            </div>
                            <div class="icat-mocks-card d-flex px-3 py-2 justify-content-between align-items-center">
                                <div class="text-card">
                                    <h6 class="f-light mb-2 text-white mt-1">iQuanta's iCAT Mocks</h6>
                                    <ul class="nav list_card d-flex flex-column text-white f-light">
                                        <li class="d-flex align-items-center">
                                            <svg class="mr-2" xmlns="http://www.w3.org/2000/svg" width="13" height="13"
                                                viewBox="0 0 17 17" fill="none">
                                                <path
                                                    d="M5.125 8.5L7.375 10.75L11.875 6.25M16 8.5C16 12.6421 12.6421 16 8.5 16C4.35786 16 1 12.6421 1 8.5C1 4.35786 4.35786 1 8.5 1C12.6421 1 16 4.35786 16 8.5Z"
                                                    stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                            Shorten your analysis by 3 times with AI
                                        </li>
                                        <li class="d-flex align-items-center mt-1">
                                            <svg class="mr-2" xmlns="http://www.w3.org/2000/svg" width="13" height="13"
                                                viewBox="0 0 17 17" fill="none">
                                                <path
                                                    d="M5.125 8.5L7.375 10.75L11.875 6.25M16 8.5C16 12.6421 12.6421 16 8.5 16C4.35786 16 1 12.6421 1 8.5C1 4.35786 4.35786 1 8.5 1C12.6421 1 16 4.35786 16 8.5Z"
                                                    stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                            Video Solutions for all Full & Sectional Mocks
                                        </li>
                                        <li class="mr-1" class="d-flex align-items-center mt-1">
                                            <svg class="mr-2" xmlns="http://www.w3.org/2000/svg" width="13" height="13"
                                                viewBox="0 0 17 17" fill="none">
                                                <path
                                                    d="M5.125 8.5L7.375 10.75L11.875 6.25M16 8.5C16 12.6421 12.6421 16 8.5 16C4.35786 16 1 12.6421 1 8.5C1 4.35786 4.35786 1 8.5 1C12.6421 1 16 4.35786 16 8.5Z"
                                                    stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                            Error & Goal Tracker
                                        </li>
                                    </ul>
                                </div>
                                <div class="buttons-card text-center pl-2">
                                    <h6 class="f-light mb-3">35 Full Mocks</h6>
                                    <div class="sec_mocks mb-2">45 Sectional Mocks</div>
                                    <button data-toggle="modal" data-target="#CATMockModal"
                                        class="btn btn-sm d-flex align-item-center justify-content-center">VIEW
                                        MORE
                                        <span
                                            class="ml-2 d-flex justify-content-center align-items-center rounded-circle">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9"
                                                viewBox="0 0 14 14" fill="none">
                                                <path d="M1 6.87948L12.7586 6.87948M6.87931 12.7588L6.87931 1.00017"
                                                    stroke="white" stroke-width="2" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                            </svg>
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6 pl-sm-2">
                        <div class="d-flex gap-2">
                            <div class="star-mentor pt-3 position-relative">
                                <div class="img pr-5">
                                    <img loading="lazy"
                                        src="https://media.iquanta.in/ui_images/home-image/mentors-image.webp"
                                        alt="CAT Coaching">
                                </div>
                                <div class="view-more-btn position-absolute">
                                    <button data-toggle="modal" data-target="#StarMentors"
                                        class="btn rounded-pill text-black f-medium">
                                        View More <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28"
                                            viewBox="0 0 37 37" fill="none">
                                            <path
                                                d="M18.5 1.00049C28.165 1.00049 36 8.8355 36 18.5005C36 28.1655 28.165 36.0005 18.5 36.0005C8.83502 36.0005 1 28.1655 1 18.5005C1 8.8355 8.83502 1.00049 18.5 1.00049Z"
                                                fill="#100703" />
                                            <path
                                                d="M18.5 1.00049L18.5 0.000488281L18.5 1.00049ZM18.5 36.0005L18.5 35.0005L18.5 36.0005ZM12 17.5005C11.4477 17.5005 11 17.9482 11 18.5005C11 19.0528 11.4477 19.5005 12 19.5005V17.5005ZM25 19.5005C25.5523 19.5005 26 19.0528 26 18.5005C26 17.9482 25.5523 17.5005 25 17.5005V19.5005ZM17.5 25.0005C17.5 25.5528 17.9477 26.0005 18.5 26.0005C19.0523 26.0005 19.5 25.5528 19.5 25.0005L17.5 25.0005ZM19.5 12.0005C19.5 11.4482 19.0523 11.0005 18.5 11.0005C17.9477 11.0005 17.5 11.4482 17.5 12.0005H19.5ZM18.5 2.00049C27.6127 2.00049 35 9.38779 35 18.5005L37 18.5005C37 8.28322 28.7173 0.000487834 18.5 0.000488281L18.5 2.00049ZM35 18.5005C35 27.6132 27.6127 35.0005 18.5 35.0005L18.5 37.0005C28.7173 37.0005 37 28.7178 37 18.5005L35 18.5005ZM18.5 35.0005C9.3873 35.0005 2 27.6132 2 18.5005L0 18.5005C4.45488e-07 28.7178 8.28273 37.0005 18.5 37.0005L18.5 35.0005ZM2 18.5005C2 9.38779 9.3873 2.00049 18.5 2.00049L18.5 0.000488281C8.28273 0.000488729 -4.45488e-07 8.28322 0 18.5005L2 18.5005ZM12 19.5005H18.5V17.5005H12V19.5005ZM18.5 19.5005H25V17.5005H18.5V19.5005ZM19.5 25.0005L19.5 18.5005L17.5 18.5005L17.5 25.0005L19.5 25.0005ZM19.5 18.5005V12.0005H17.5V18.5005H19.5Z"
                                                fill="white" />
                                        </svg></button>
                                </div>
                            </div>
                            <div class="star-mentor pt-2 position-relative">
                                <div class="img pr-4">
                                    <img loading="lazy" src="https://media.iquanta.in/ui_images/home-image/Result.webp"
                                        alt="CAT Coaching">
                                </div>
                                <div class="view-more-btn btn_ver position-absolute">
                                    <button data-toggle="modal" data-target="#CATToppers"
                                        class="btn rounded-pill text-black f-medium">
                                        View More <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28"
                                            viewBox="0 0 37 37" fill="none">
                                            <path
                                                d="M18.5 1.00049C28.165 1.00049 36 8.8355 36 18.5005C36 28.1655 28.165 36.0005 18.5 36.0005C8.83502 36.0005 1 28.1655 1 18.5005C1 8.8355 8.83502 1.00049 18.5 1.00049Z"
                                                fill="#100703" />
                                            <path
                                                d="M18.5 1.00049L18.5 0.000488281L18.5 1.00049ZM18.5 36.0005L18.5 35.0005L18.5 36.0005ZM12 17.5005C11.4477 17.5005 11 17.9482 11 18.5005C11 19.0528 11.4477 19.5005 12 19.5005V17.5005ZM25 19.5005C25.5523 19.5005 26 19.0528 26 18.5005C26 17.9482 25.5523 17.5005 25 17.5005V19.5005ZM17.5 25.0005C17.5 25.5528 17.9477 26.0005 18.5 26.0005C19.0523 26.0005 19.5 25.5528 19.5 25.0005L17.5 25.0005ZM19.5 12.0005C19.5 11.4482 19.0523 11.0005 18.5 11.0005C17.9477 11.0005 17.5 11.4482 17.5 12.0005H19.5ZM18.5 2.00049C27.6127 2.00049 35 9.38779 35 18.5005L37 18.5005C37 8.28322 28.7173 0.000487834 18.5 0.000488281L18.5 2.00049ZM35 18.5005C35 27.6132 27.6127 35.0005 18.5 35.0005L18.5 37.0005C28.7173 37.0005 37 28.7178 37 18.5005L35 18.5005ZM18.5 35.0005C9.3873 35.0005 2 27.6132 2 18.5005L0 18.5005C4.45488e-07 28.7178 8.28273 37.0005 18.5 37.0005L18.5 35.0005ZM2 18.5005C2 9.38779 9.3873 2.00049 18.5 2.00049L18.5 0.000488281C8.28273 0.000488729 -4.45488e-07 8.28322 0 18.5005L2 18.5005ZM12 19.5005H18.5V17.5005H12V19.5005ZM18.5 19.5005H25V17.5005H18.5V19.5005ZM19.5 25.0005L19.5 18.5005L17.5 18.5005L17.5 25.0005L19.5 25.0005ZM19.5 18.5005V12.0005H17.5V18.5005H19.5Z"
                                                fill="white" />
                                        </svg></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>

</div>